import {Component, ElementRef, EventEmitter, Inject, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry, MatSnackBar, MatTabGroup} from '@angular/material';
import {environment} from '../../environments/environment';
import {ConnecttocrudService} from '../connecttocrud.service';
import {KongService} from '../kong.service';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxXml2jsonService} from 'ngx-xml2json';
import {DomSanitizer} from '@angular/platform-browser';
import {DialogData} from '../partner-onboard/partner-onboard.component';
import {Location} from '@angular/common';
import {AppComponent} from '../app.component';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {ListenerService} from '../listener.service';
import {AddGatewayResourceComponent, LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {DataaccessListenerService} from '../dataaccess-listener.service';
import {AttributeDescriptionComponent, UseExistingTableConfirmationComponent} from '../crudapi/crudapi.component';
import {ApimanagementComponent} from '../apimanagement/apimanagement.component';
import {ApiRegistrarSettingsComponent} from '../settings/api-registrar-settings/api-registrar-settings.component';
import {TourStep} from 'ngx-guided-tour/lib/guided-tour.constants';
import {Orientation} from 'ngx-guided-tour';
import {WebsocketService} from '../websocket.service';
import {ApiCreatorsService} from '../api-creators.service';
import {AuditListenerService} from '../audit-listener.service';
import {AccountInfoService} from '../user/account-info.service';
import {AuditLogService} from '../audit-log.service';


export interface ICategory {
    name: string;
}

export interface EntityVersions {
    name: string;
}

export interface MethodTypes {
    id: string;
    itemName: string;
}

declare let $;
const incr = 5;

@Component({
    selector: 'app-crudapi-advanced',
    templateUrl: './crudapi-advanced.component.html',
    styleUrls: ['./crudapi-advanced.component.scss']
})
export class CrudapiAdvancedComponent implements OnInit, OnChanges {
    @ViewChild('dataaccessadvanced') dataaccessadvanced: MatTabGroup;
    selectedTab = 0;
    selectedTab1 = 0;
    myControl = new FormControl();
    progress = 0;
    progressMessage: string;
    apiCategory: string;
    tableName: any;
    tableLabelName = 'Table Name';
    version: string;
    entityName: any;
    countPartnerEntities: any;
    countPartnerAccountEntities: any;
    displayName: string;
    attributeName: string;
    description: string;
    required: boolean;
    importDataDB: boolean;
    listofTables: boolean;
    useReferentialKeys: boolean;
    databaseName: string;
    targetDatabase: string;
    APILoading = false;
    buttonClick = false;
    APILoadingdB = false;
    buttonClickdB = false;
    save: boolean;
    error = true;
    flag: any;
    flagValue = true;
    errorMessage: any;
    dberror = true;
    selectedItems = [];
    loading = false;
    Blocks = [];
    destroy: any;
    entityAndVersion: any;
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    apiByDefinition: any;
    authModel: any;
    headers = [];
    queryParams = [];
    requestBody: any;
    prerequisites: any;

    filteredOptions: Observable<ICategory[]>;
    entityVersions: EntityVersions[] = [
        {name: 'v1'},
        {name: 'v2'},
        {name: 'v3'},
        {name: 'v4'},
        {name: 'v5'},
        {name: 'v6'},
        {name: 'v7'},
        {name: 'v8'},
        {name: 'v9'},
        {name: 'v10'}
    ];

    settings = {
        text: 'Select API Method Types *',
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    // methodType: string;
    methodTypes: MethodTypes[] = [
        {id: 'GET', itemName: 'GET'},
        {id: 'PUT', itemName: 'PUT'},
        {id: 'POST', itemName: 'POST'},
        {id: 'DELETE', itemName: 'DELETE'},
        {id: 'PATCH', itemName: 'PATCH'}
    ];

    methodType = [];

    selectDatabase: string;
    selectedDatabaseType: string;
    selectGateway = 'default';
    ispublished = true;

    databases: any;
    gateways = [
        {
            gateway_name: 'default',
            gateway_type: 'apiplatform'
        }
    ];
    datatypes: any;
    dataTypeFilter: any;
    selectedDatatypeFilter: string;
    isSelectedDatabaseNatureNoSQL: any;
    options: any;
    url = environment.konghost;
    attributes = ['None', 'Primary', 'Unique'];
    data = ['String',
        'Integer',
        'Date',
        'Double',
        'Timestamp',
        'Boolean',
        'Array',
        'Array Of Strings',
        'Object',
        'ObjectId'
    ];
    importData: boolean;
    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    collectionTypes = [{'displayName': 'Create New Collection', 'value': 'new'}, {
        'displayName': 'Use Existing Collection',
        'value': 'existing'
    }
    ];
    collectionTypeSelected = 'new';
    scopeSelected = 'public';
    account = new FormControl();
    accounts = ['default'];
    partner = localStorage.getItem('partner');
    partnerKey = localStorage.getItem('partnerKey');
    account_id = localStorage.getItem('account');
    gatewayUrl: any;
    gatewayFullUrl: string;
    // = (this.partner === this.account ? 'https://gateway.' + this.partner + '.apiplatform.io' : 'https://gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    apiKey = localStorage.getItem('apikey');
    showNextPanel = false;
    angular: any;
    accept = false;

    // entities: any;
    // entityTypes = [];
    enableBlockly = false;
    jwtOrig: any;
    ipRestriction: any;
    isSpecialCharacterInAttribute = false;
    dataTypeArray: any;
    // customType = false;
    previousSavedData: any;
    isValidTableName = false;
    partnerEntities: any;
    partnerExecutors: any;
    isAPIDefinitionImportedFromExistingTable = false;
    settingsData: any;
    APIGateways: any;
    selectedAPIGateway: any;
    selectedAPIGatewayName: any;
    isUseExistingTable = false;

    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild('myTable') tableNameField: ElementRef;
    @ViewChild('myTable1') tableNameField1: ElementRef;
    options1 = new JsonEditorOptions();
    JSONdata = [{
        'apiAccessPolicy': 'string',
        'attributeName': 'string',
        'type': null,
        'size': null,
        'precision': null,
        'autoIncrement': false,
        'defaultValue': null,
        'attributeType': 'string',
        'dataStoragePolicy': 'string',
        'description': 'string',
        'displayName': 'string',
        'displayPolicy': 'string',
        'required': false,
        'subType': []

    }];
    autoIncrement = [];
    yamlData: any;
    hideBreadcrumb = false;
    route: any;
    enableMonacoEditor = false;

    entity: any;
    origEntity: any;
    origVersion: any;
    items: any;
    origCollection: any;
    content: boolean;
    cloneEnable: boolean;
    selection: any;
    contentLoading = true;
    cloneable = false;
    cloneWithData = false;
    isAPIAlreadyPresent: boolean;
    componentLoading = true;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;
    isCheckForExistingTable = true;
    isCheckForExistingTableCompleted = false;
    invokingCheckForExistingTableFromDeploy = false;
    previousTableName: string;
    previousSelectedDatatypeFilter: string;
    existingTables: any;
    gatewayService: any;
    gatewayRoute: any;
    refreshedMethodTypes = [];
    methods = [];
    existingTablesLoading = false;
    responseConfigurationsMethodWise = [];
    referentialKeyConstraints = [];
    fromHistory = false;
    logVisible = false;
    logComponentRefresh = false;
    logTimeStamp: any;
    refreshLogCount = 0;
    currentMessage: any;
    apiType = 'DATAACCESS';
    connection: any;
    action: any;
    showDialogOnNonWebsocketConnection: any;
    partnerShortCode: any;
    loggedInEnvironment: any;

    constructor(private confPost: ConfService,
                private kongService: KongService,
                public websocketService: WebsocketService,
                public dialog: MatDialog,
                private _service: ConnecttocrudService,
                private router: Router,
                private location: Location,
                private _route: ActivatedRoute,
                private appComp: AppComponent, public listenerServiceInstance: ListenerService,
                private apiCreatorService: ApiCreatorsService,
                private auditListenerService: AuditListenerService,
                public accountInfoService: AccountInfoService, private auditLog: AuditLogService,
                private leftPanelDataListener: ListenerService, public platform: LeftpanelComponent, private dataAccessListenerInstance: DataaccessListenerService, public apigatewayInstance: ApimanagementComponent,
                private ngxXml2jsonService: NgxXml2jsonService, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        // this.options1.onChange = () => console.log(/* this.editor.get()*/);
        iconRegistry.addSvgIcon(
            'video',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/video.svg'));

        this.apiCreatorService.eventCallback$.subscribe(value => {

            if (value.apiName === this.entityName && value.apiVersion === this.version) {
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
                if (!this.websocketService.isOpen()) {
                    this.logVisible = true;
                    this.refreshLogCount++;
                }
            }
        });

        const temp = this.partner.split('-');
        this.partnerShortCode = temp[temp.length - 1];
        if (temp.length > 1) {
            this.loggedInEnvironment = temp[0];
        } else {
            this.loggedInEnvironment = 'prod';
        }
    }

    updateGatewayRoutePaths(object) {
        // console.log(object);
        if (object && object.hasOwnProperty('routePathData') && object.hasOwnProperty('routeIndex')) {
            this.apigatewayInstance.gatewayRoute.data[object.routeIndex].paths = object.routePathData;
        }
    }

    emitIpRestriction(event) {
        if (event.value === 'public') {
            this.listenerServiceInstance.emitIPRestriction.emit({type: this.selectedAPIGateway['type'], status: false});
        } else {
            this.listenerServiceInstance.emitIPRestriction.emit({type: this.selectedAPIGateway['type'], status: true});
        }
    }

    addnewrow(val) {
        this.addAttributeField(this.apiByDefinition, this.selectDatabase);
    }

    Change() {
        this.ispublished = !this.ispublished;
    }

    stringify() {
        return JSON.stringify(this.methodType);
    }

    addAllMethodsToResponseConfigurations() {
        this.responseConfigurationsMethodWise = [];
        const methodTypes = [];
        this.methodType.forEach(method => {
            methodTypes.push(method.id);
        });
        this.methods = methodTypes;
        for (const method of this.methods) {
            if (method) {
                if ((this.responseConfigurationsMethodWise.filter(element => element.method === method)).length === 0) {
                    if (method === 'PUT' || method === 'PATCH' || method === 'POST') {
                        this.responseConfigurationsMethodWise.push({
                            method: method,
                            apiResponseDetails: [],
                            payloadAsResponse: false,
                            description: '',
                            schemaValidation: true,
                            mockResponses: [],
                            content: []
                        });
                    } else if (method === 'GET') {
                        this.responseConfigurationsMethodWise.push({
                            method: method,
                            apiResponseDetails: [],
                            description: '',
                            content: [],
                            mockResponses: []
                        });
                    } else {
                        this.responseConfigurationsMethodWise.push({
                            method: method,
                            apiResponseDetails: [],
                            description: '',
                            mockResponses: [],
                            content: []
                        });
                    }
                }
            }
        }
        this.apigatewayInstance.methodTypeListener.emit({
            methodType: this.methods,
            entityName: this.entityName,
            version: this.version,
            isEdit: false,
            selectedGatewayObject: this.selectedAPIGateway
        });
    }

    addMethodToResponseConfiguration(event) {
        if (event.id === 'PUT' || event.id === 'PATCH' || event.id === 'POST') {
            this.responseConfigurationsMethodWise.push({
                method: event.id,
                apiResponseDetails: [],
                payloadAsResponse: false,
                description: '',
                schemaValidation: true,
                mockResponses: [],
                content: []
            });
        } else if (event.id === 'GET') {
            this.responseConfigurationsMethodWise.push({
                method: event.id,
                apiResponseDetails: [],
                description: '',
                content: [],
                mockResponses: []
            });
        } else {
            this.responseConfigurationsMethodWise.push({
                method: event.id,
                apiResponseDetails: [],
                description: '',
                mockResponses: [],
                content: []
            });
        }
    }

    removeMethodFromResponseConfiguration(event) {
        for (let i = 0; i < this.responseConfigurationsMethodWise.length; i++) {
            if (this.responseConfigurationsMethodWise[i] && this.responseConfigurationsMethodWise[i] !== null && this.responseConfigurationsMethodWise[i] !== undefined) {
                if (this.responseConfigurationsMethodWise[i]['method'] === event.id) {
                    this.responseConfigurationsMethodWise.splice(i, 1);
                }
            }
        }
    }

    removeAllMethodsToResponseConfigurations() {
        this.responseConfigurationsMethodWise = [];
    }

    emitMethodType() {
        const methodTypes = [];
        this.methodType.forEach(method => {
            methodTypes.push(method.id);
        });
        this.methods = methodTypes;
        this.methods.push('OPTIONS');
        this.apigatewayInstance.methodTypeListener.emit({
            methodType: this.methods,
            entityName: this.entityName,
            version: this.version,
            isEdit: false,
            selectedGatewayObject: this.selectedAPIGateway
        });
    }

    addAttributeField(data, database) {
        this.autoIncrement.push(false);
        if (database === 'mongodb' || database === 'default') {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'array': false,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            data.push(newField);
        } else {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            data.push(newField);
        }
    }

    emitChange(val) {
        // console.log('val', val);
        this.selection = val;
        if (this.selectedAPIGateway && this.selectedAPIGateway['type'] === 'kong') {
            for (const plugin of this.selection) {
                if (plugin && plugin !== null && plugin !== undefined) {
                    if (plugin['name'] === 'ip-restriction') {
                        if (plugin['enabled'] === true) {
                            this.scopeSelected = 'private';
                        } else {
                            this.scopeSelected = 'public';
                        }
                    }
                }
            }
        }
    }

    async ngOnChanges() {
        this.gatewayService = {
            name: this.partner + '-' + this.account + '-' + this.entity + '-' + this.version,
            protocol: 'https',
            host: 'services.apiplatform.io',
            port: 443,
            retries: 5,
            connect_timeout: 60000,
            read_timeout: 60000,
            write_timeout: 60000,
            tags: [],
            client_certificate: ''
        };
        const methodTypes = [];
        this.methodType.forEach(method => {
            methodTypes.push(method.id);
        });
        this.gatewayRoute = {
            data: [
                {
                    name: this.partner + '-' + this.account + '-' + this.entity + '-' + this.version + '-path',
                    protocols: 'https,http',
                    hosts: await this.platform.getDefaultGatewayURL(),
                    paths: '/' + this.version + '/' + this.entity,
                    methods: methodTypes
                }
            ]
        };
    }

    omit_special_char(event) {

        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
        return (k !== 95);
    }

    checkNumber(event) {
        let k;
        k = event.charCode;
        return ((k >= 48 && k <= 57));
    }

    checkDefault(event, val) {
        if (val === true) {
            let k;
            k = event.charCode;
            return ((k >= 48 && k <= 57));
        }
    }

    typeCheck(definition, type, index) {
        for (let i = 0; i < this.dataTypeFilter.length; i++) {
            if (this.dataTypeFilter[i]['data_types'][0]['type'] === type) {
                if (this.dataTypeFilter[i]['data_types'][0]['family'] === 'Number') {
                    this.autoIncrement[index] = true;
                } else {
                    this.apiByDefinition[index]['autoIncrement'] = false;
                    this.autoIncrement[index] = false;
                }
            }
        }
        const entityAndVersionCheckString = definition.type,
            substring = '_';
        if (entityAndVersionCheckString.includes(substring)) {
            definition.customType = true;
            definition.attributeType = 'DBRef';
            definition.array = true;
        } else {
            definition.customType = false;
            if (definition.attributeType === 'Primary') {
                this.flagValue = true;
                definition.autoIncrement = false;
                definition.required = false;
            }
            definition.attributeType = 'None';
            definition.array = false;
        }

        if (this.selectDatabase === 'default' || this.selectDatabase === 'mongo') {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition.subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        } else {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition.subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        }
    }

    removeAttributeField(data) {
        for (let i = 0; i < data.length; i++) {
            data.splice(i, 1);
        }
    }

    removeAttribute(data, index) {
        if (confirm('Are you sure you want to remove this attribute?')) {
            this.autoIncrement.splice(index, 1);
            data.splice(index, 1);
        }
    }

    setPrimaryFlag(i, type) {
        if (type === 'Primary' && this.flagValue) {
            this.flag = i;
            this.flagValue = false;
        } else if (i === this.flag && !this.flagValue && type !== 'Primary') {
            this.flag = null;
            this.flagValue = true;
            this.apiByDefinition[i]['autoIncrement'] = false;
        }
        if (type === 'Primary') {
            this.apiByDefinition[i]['required'] = true;
        } else {
            this.apiByDefinition[i]['required'] = false;
        }
    }

    onInit(editor) {
        const line = editor.getPosition();

    }

    enableMonaco(ev) {
        if (ev.tab.textLabel.trim() === 'Open API') {
            this.enableMonacoEditor = true;
        }
        if (ev.tab.textLabel.trim() === 'Business Logic') {
            this.enableBlockly = true;
        } else {
            //  this.enableMonacoEditor = false;
        }

    }

    setSelectedAPIGateway(event) {
        for (const envs of this.settingsData['body'][0]['environments']) {
            if (envs && envs !== null && envs !== undefined) {
                if (envs['name'] === localStorage.getItem('partner')) {
                    if (envs['services']) {
                        const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                        for (const gateway of gatewayService[0]['configurations']) {
                            if (gateway && gateway !== null && gateway !== undefined) {
                                if (gateway['name'] === event) {
                                    this.selection = gateway['gateway_configurations'];
                                    this.selectedAPIGateway = gateway;
                                    this.selectedAPIGatewayName = gateway['name'];
                                    this.apigatewayInstance.APIGatewayListener.emit({selectedAPIGateway: this.selectedAPIGateway});
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    getDefaultGatewaySettings(settingsData) {
        for (const envs of settingsData['body'][0]['environments']) {
            if (envs && envs !== null && envs !== undefined) {
                if (envs['name'] === localStorage.getItem('partner')) {
                    if (envs['services']) {
                        const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                        if (gatewayService[0]['configurations'] && gatewayService[0]['configurations'] !== null && gatewayService[0]['configurations'] !== undefined && gatewayService[0]['configurations'].length > 0) {
                            this.APIGateways = gatewayService[0]['configurations'];
                        }
                        for (const gateway of gatewayService[0]['configurations']) {
                            if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                                this.platform.defaultGatewaySettings = gateway['gateway_configurations'];
                                this.selection = gateway['gateway_configurations'];
                                this.selectedAPIGateway = gateway;
                                this.selectedAPIGatewayName = gateway['name'];
                                this.apigatewayInstance.APIGatewayListener.emit({selectedAPIGateway: this.selectedAPIGateway});
                            }
                        }
                    }
                }
            }
        }
    }

    hasViewPagePermissions() {
        if (this.fromHistory === true) {
            return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_DATA_ACCESS_API_ADVANCED']));
        } else {
            return this.platform.hasPlatformPermission('CREATE_DATA_ACCESS_API_ADVANCED');
        }
    }

    async ngOnInit() {


        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        this.selection = this.platform.defaultGatewaySettings;
        const temp = localStorage.getItem('partner').split('-');
        let partnerShortCode = '';
        let env = '';
        if (temp.length > 1) {
            partnerShortCode = temp[temp.length - 1];
            env = temp[0];
        } else {
            partnerShortCode = temp[0];
            env = 'prod';
        }
        const isEnvironmentPresentInAdmin = false;
        const envInAdminCount = 0;
        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined && this.platform.settingsData !== '') {
            this.settingsData = this.platform.settingsData;
            this.getDefaultGatewaySettings(this.settingsData);
        } else {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(settingsData => {
                if (settingsData['body'] && settingsData['body'][0]) {
                    this.settingsData = settingsData;
                    this.getDefaultGatewaySettings(this.settingsData);
                }
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving settings data. Please try again after sometime.');
            });
        }
        // this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerShortCode, false).subscribe(response => {
        //     if (response['body'] && response['body'][0]) {
        //         this.platform.adminSettingsData = response;
        //         response['body'][0]['environments'].forEach(environment => {
        //             if (environment['type'] === 'admin') {
        //                 if (environment['services']) {
        //                     const gatewayService = environment['services'].filter(element => element.type === 'apigateway');
        //                     if (gatewayService[0]['configurations'][0]['gateway_configurations'] !== {}) {
        //                         this.platform.defaultGatewaySettings = gatewayService[0]['configurations'][0]['gateway_configurations'];
        //                         this.selection = gatewayService[0]['configurations'][0]['gateway_configurations'];
        //                     }
        //                 }
        //             }
        //             envInAdminCount += 1;
        //             if (environment['type'] === env) {
        //                 isEnvironmentPresentInAdmin = true;
        //             };
        //         });
        //     }
        // }, error => {
        //     this.platform.openSnackBar(error.error.message, 'Error', {
        //         duration: 15000,
        //         verticalPosition: 'top',
        //         horizontalPosition: 'center'
        //     });
        // });

        this.gatewayService = {
            name: this.partner + '-' + this.account + '-' + this.entityName + '-' + this.version,
            protocol: 'https',
            host: 'services.apiplatform.io',
            port: 443,
            retries: 5,
            connect_timeout: 60000,
            read_timeout: 60000,
            write_timeout: 60000,
            tags: [],
            client_certificate: ''
        };
        const methodTypes = [];
        this.methodType.forEach(method => {
            methodTypes.push(method.id);
        });
        this.gatewayRoute = {
            data: [
                {
                    name: this.partner + '-' + this.account + '-' + this.entityName + '-' + this.version + '-path',
                    protocols: 'https,http',
                    hosts: await this.platform.getDefaultGatewayURL(),
                    paths: '/' + this.version + '/' + this.entity,
                    methods: []
                }
            ]
        };

        this.appComp.currentPageTitle = 'Create Data Access API';
        this.gatewayUrl = await this.platform.getDefaultGatewayURL();
        this.gatewayFullUrl = 'https://' + this.gatewayUrl;
        this.router.events.subscribe(event => {
            this.route = this.location.path();
            if (this.route.includes('/swifter')) {
                this.hideBreadcrumb = true;
            } else {
                this.hideBreadcrumb = false;
            }
        });

        if (this.location.path() !== '') {
            this.route = this.location.path();
            if (this.route.includes('/swifter')) {
                this.hideBreadcrumb = true;
            } else {
                this.hideBreadcrumb = false;
            }
        }

        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
        } else {
            await this.confPost.getDataTypes().toPromise().then(data => {
                    this.datatypes = data;
                    this.platform.datatypes = data;
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of data types. Please try again after sometime.');
                });
        }

        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            await this.platform.updateIsNoSQLForMongo(this.platform.databases);
            this.databases = this.platform.databases;
        } else {
            // this.platform.getDatabasesForPartnerAccount();
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                    await this.platform.updateIsNoSQLForMongo(databases);
                    this.databases = this.platform.databases;
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                });
            // this.databases = this.platform.databases;
        }
        // this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {

        if (this.platform.partnerCategories !== null && this.platform.partnerCategories !== undefined) {
            this.options = this.platform.partnerCategories;
            if (this.options !== null && this.options !== undefined) {
                this.filteredOptions = this.myControl.valueChanges
                    .pipe(
                        startWith<string | ICategory>(''),
                        map(value => typeof value === 'string' ? value : value.name),
                        map(name => name ? this._filter(name) : this.options.slice())
                    );
            }

        } else {
            await this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
                this.options = data;
                this.platform.partnerCategories = this.options;
                if (this.options !== null && this.options !== undefined) {
                    this.filteredOptions = this.myControl.valueChanges
                        .pipe(
                            startWith<string | ICategory>(''),
                            map(value => typeof value === 'string' ? value : value.name),
                            map(name => name ? this._filter(name) : this.options.slice())
                        );
                }
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving data access services group by categories for your account. Please try again after sometime.');
            });
        }

        // });

        // if (this.platform.countPartnerAccountEntities !== null && this.platform.countPartnerAccountEntities !== undefined) {
        //     this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
        // } else {
        //     this.platform.getEntityCountForPartnerAccount();
        //     this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
        // }
        // if (this.platform.countPartnerEntities !== null && this.platform.countPartnerEntities !== undefined) {
        //     this.countPartnerEntities = this.platform.countPartnerEntities;
        // } else {
        //     this.platform.getEntityCountForPartner();
        //     this.countPartnerEntities = this.platform.countPartnerEntities;
        // }

        this._route.queryParams
            .subscribe(async params => {
                this.cloneable = false;
                this.fromHistory = false;
                if (params.clone) {
                    this.cloneable = true;
                    if (params.data === 'true') {
                        this.cloneWithData = true;
                    }
                    if (this.platform.cloneableData) {
                        if (this.platform.cloneableData['database'] !== 'default') {
                            for (let i = 0; i < this.platform.cloneableData['attributes'].length; i++) {
                                this.platform.cloneableData['attributes'][i]['updateOption'] = 'none';
                            }
                        }
                        this.apiByDefinition = this.platform.cloneableData['attributes'];
                        this.entityName = this.platform.cloneableData['entityname'];
                        this.version = this.platform.cloneableData['version'];
                        this.tableName = this.platform.cloneableData['tableName'];
                        this.apiCategory = this.platform.cloneableData['category'];
                        this.displayName = this.platform.cloneableData['displayname'];
                        this.ispublished = this.platform.cloneableData['published'];
                        // this.selectDatabase = this.platform.cloneableData['database'];
                        // this.filterDataTypes(this.selectDatabase);
                        this.description = this.platform.cloneableData['description'];
                        if (this.platform.cloneableData.methods
                            && this.platform.cloneableData.methods !== null
                            && this.platform.cloneableData.methods !== undefined
                            && this.platform.cloneableData.methods.length > 0) {
                            this.methodType = [];
                            this.platform.cloneableData.methods.forEach(method => {
                                this.methodType.push({'id': method, 'itemName': method});
                            });
                            // this.methodType = this.items.methods;
                            // this.origMethods = this.items.methods;
                        } else {
                            this.methodType = this.methodTypes;
                        }
                        if (this.platform.cloneableData.hasOwnProperty('referentialKeyConstraints')) {
                            if (this.platform.cloneableData['referentialKeyConstraints'] !== null && this.platform.cloneableData['referentialKeyConstraints'] !== undefined) {
                                this.referentialKeyConstraints = this.platform.cloneableData['referentialKeyConstraints'];
                            }
                        }
                        this.origCollection = this.platform.cloneableData['tableName'];
                        this.content = true;
                        this.ispublished = this.platform.cloneableData['published'];
                        await this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async data => {
                            await this.platform.updateIsNoSQLForMongo(data);
                            this.databases = this.platform.databases;
                            this.filterDataTypes(this.platform.cloneableData.database);
                        }, error => {
                            this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                        });
                        let isCloneableDBPresent = false;
                        this.databases.forEach((database) => {
                            if (database) {
                                if (database['database_name'] === this.platform.cloneableData.database) {
                                    isCloneableDBPresent = true;
                                }
                            }
                        });
                        if (isCloneableDBPresent === false) {
                            this.databases.push({'database_name': this.platform.cloneableData.database, 'database_type': ''});
                        }
                        this.selectDatabase = this.platform.cloneableData.database;
                        this.filterDataTypes(this.platform.cloneableData.database);
                        if (this.partner === 'commons' || this.partner === 'templates') {
                            this.cloneEnable = true;
                        }
                        this.contentLoading = false;
                    } else {
                        this.router.navigateByUrl('/dataaccessapi');
                    }

                } else if (params.timestamp && params.timestamp !== '') {
                    this.fromHistory = true;
                    this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + this.partner + '&account=' + this.account_id + '&at=' + params.timestamp).subscribe(response => {
                        if (response && response !== null && response !== undefined && response[0] && response[0]['executor']) {
                            const executor = response[0]['executor'];
                            this.entityName = executor.entityname;
                            this.apiCategory = executor.category;
                            this.tableName = executor.tableName;
                            this.displayName = executor.displayname;
                            this.description = executor.description;
                            this.ispublished = executor.published;
                            this.scopeSelected = executor.scopeOfAccess;
                            this.selectDatabase = executor.database;
                            this.filterDataTypes(this.selectDatabase);
                            this.version = executor.version;
                            this.apiByDefinition = executor.attributes;
                            if (executor.methods && executor.methods !== null && executor.methods !== undefined && executor.methods.length > 0) {
                                this.methodType = [];
                                executor.methods.forEach(method => {
                                    this.methodType.push({'id': method, 'itemName': method});
                                });
                            } else {
                                this.methodType = this.methodTypes;
                            }
                            if (executor.hasOwnProperty('referentialKeyConstraints')) {
                                if (executor['referentialKeyConstraints'] !== null && executor['referentialKeyConstraints'] !== undefined) {
                                    this.referentialKeyConstraints = executor['referentialKeyConstraints'];
                                }
                            }
                            for (const event of this.methodType) {
                                if (event.id === 'PUT' || event.id === 'PATCH' || event.id === 'POST') {
                                    this.responseConfigurationsMethodWise.push({
                                        method: event.id,
                                        apiResponseDetails: [],
                                        payloadAsResponse: false,
                                        description: '',
                                        schemaValidation: true,
                                        mockResponses: [],
                                        content: []
                                    });
                                } else if (event.id === 'GET') {
                                    this.responseConfigurationsMethodWise.push({
                                        method: event.id,
                                        apiResponseDetails: [],
                                        description: '',
                                        content: [],
                                        mockResponses: []
                                    });
                                } else {
                                    this.responseConfigurationsMethodWise.push({
                                        method: event.id,
                                        apiResponseDetails: [],
                                        description: '',
                                        mockResponses: [],
                                        content: []
                                    });
                                }
                            }
                            this.contentLoading = false;
                        } else {
                            this.contentLoading = false;
                            this.platform.openSnackBar('Error in retrieving the history for this API', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }, error => {
                        this.contentLoading = false;
                        this.platform.handleErrorGracefully(error, 'Error in retrieving the history for this API. Please try again after sometime.');
                    });
                } else {
                    this.contentLoading = false;
                    this.entityName = '';
                    this.apiCategory = '';
                    this.tableName = '';
                    this.displayName = '';
                    this.description = '';
                    this.ispublished = true;
                    this.scopeSelected = 'public';
                    this.selectDatabase = '';
                    this.version = '';
                    this.methodType = [];
                    this.referentialKeyConstraints = [];
                    this.apiByDefinition = [{
                        'customType': false,
                        'apiAccessPolicy': 'None',
                        'attributeName': null,
                        'type': null,
                        'array': false,
                        'size': null,
                        'precision': null,
                        'autoIncrement': false,
                        'defaultValue': null,
                        'attributeType': 'None',
                        'dataStoragePolicy': 'None',
                        'description': null,
                        'displayName': null,
                        'displayPolicy': 'None',
                        'required': false,
                        'subType': []

                    }];
                }
            });

        $(document).on('click', '.removeHeader', function () {
            $(this).closest('td').parent('tr').remove();
        });

        this.platform.setGuideTourSteps(this.getDaasAdvancedSteps());
    }

    tabChanged(event) {
        this.selectedTab = event.index;
    }

    tabChanged1(event) {
        this.selectedTab1 = event.index;
    }

    getDaasAdvancedSteps(): Array<TourStep> {

        const currentSelectedTab = this.selectedTab;
        let steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_DAASA_INTRO_TITLE'),
            content: this.platform.getProperty('GT_DAASA_INTRO_CONTENT'),
        }, {
            title: this.platform.getProperty('API_NAME_TITLE'),
            selector: '.tour-create-daas-advanced-api-name',
            content: this.platform.getProperty('API_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('API_VERSION_TITLE'),
            selector: '.tour-create-daas-advanced-api-version',
            content: this.platform.getProperty('API_VERSION_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('API_CATEGORY_TITLE'),
            selector: '.tour-create-daas-advanced-api-category',
            content: this.platform.getProperty('API_CATEGORY_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('API_METHODS_TITLE'),
            selector: '.tour-create-daas-advanced-method-type > angular2-multiselect > div.cuppa-dropdown',
            content: this.platform.getProperty('API_METHODS_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_DAASA_DATA_STORAGE_TAB_TITLE'),
            selector: '.tour-create-daas-advanced-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(1)',
            content: this.platform.getProperty('GT_DAASA_DATA_STORAGE_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 0;
            })
        }, {
            title: this.platform.getProperty('SELECT_DATABASE_FOR_API_TITLE'),
            selector: '.tour-create-daas-advanced-data-storage-database',
            content: this.platform.getProperty('SELECT_DATABASE_FOR_API_CONTENT'),
            orientation: Orientation.Bottom
        });

        steps = steps.concat(this.platform.getSchemaDefinitionTourSteps(false));

        steps.push({
            title: this.platform.getProperty('GT_DAASA_API_GATEWAY_TAB_TITLE'),
            selector: '.tour-create-daas-advanced-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(2)',
            content: this.platform.getProperty('GT_DAASA_API_GATEWAY_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 1;
            })
        }, {
            title: this.platform.getProperty('PUBLISH_API_TITLE'),
            selector: '.tour-create-daas-advanced-publish',
            content: this.platform.getProperty('PUBLISH_API_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('API_GATEWAY_TITLE'),
            selector: '.tour-create-daas-advanced-api-gateway',
            content: this.platform.getProperty('API_GATEWAY_CONTENT'),
            orientation: Orientation.Bottom
        });

        steps = steps.concat(this.platform.getApiManagementTourSteps());

        steps.push({
            title: this.platform.getProperty('GT_DAASA_API_METHOD_DEF_TAB_TITLE'),
            selector: '.tour-create-daas-advanced-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(3)',
            content: this.platform.getProperty('GT_DAASA_API_METHOD_DEF_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 2;
            })
        });

        steps.push({
            title: this.platform.getProperty('GT_DAASA_CACHE_TAB_TITLE'),
            selector: '.tour-create-daas-advanced-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(4)',
            content: this.platform.getProperty('GT_DAASA_CACHE_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 3;
            })
        }, {
            title: this.platform.getProperty('CACHE_TITLE'),
            selector: '.tour-cache-checkbox',
            content: this.platform.getProperty('CACHE_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('GT_DAASA_DESCRIPTION_TAB_TITLE'),
            selector: '.tour-create-daas-advanced-tabs > mat-tab-header > div:nth-child(2) > div > div > div:nth-child(5)',
            content: this.platform.getProperty('GT_DAASA_DESCRIPTION_TAB_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {
                this.selectedTab = 4;
            })
        }, {
            title: this.platform.getProperty('API_DISPLAY_NAME_TITLE'),
            selector: '.tour-create-daas-advanced-api-display-name',
            content: this.platform.getProperty('API_DISPLAY_NAME_CONTENT'),
            orientation: Orientation.Bottom
        }, {
            title: this.platform.getProperty('API_DESCRIPTION_TITLE'),
            selector: '.tour-create-daas-advanced-api-description',
            content: this.platform.getProperty('API_DESCRIPTION_CONTENT'),
            orientation: Orientation.Bottom,
            closeAction: (() => {
                this.selectedTab = currentSelectedTab;
            })
        }, {
            title: this.platform.getProperty('GT_DAASA_SAVE_API_TITLE'),
            selector: '.tour-create-daas-advanced-save-api',
            content: this.platform.getProperty('GT_DAASA_SAVE_API_CONTENT'),
            orientation: Orientation.Left
        }, {
            title: this.platform.getProperty('GT_DAASA_DEPLOY_API_TITLE'),
            selector: '.tour-create-daas-advanced-deploy-api',
            content: this.platform.getProperty('GT_DAASA_DEPLOY_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;

    }

    // getEntitiesForPartnerAccount(partner, account) {
    //     this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
    //         this.entities = data;
    //         this.entities.forEach(entity => {
    //             this.entityTypes.push(entity.entityname + '_' + entity.version);
    //         });
    //     });
    // }

    reInitializeAPIDefinition() {
        this.apiByDefinition = [{
            'customType': false,
            'apiAccessPolicy': 'None',
            'attributeName': null,
            'type': null,
            'array': false,
            'size': null,
            'precision': null,
            'autoIncrement': false,
            'defaultValue': null,
            'attributeType': 'None',
            'dataStoragePolicy': 'None',
            'description': null,
            'displayName': null,
            'displayPolicy': 'None',
            'required': false,
            'subType': []

        }];
        this.isAPIDefinitionImportedFromExistingTable = false;
    }

    // getCustomTypes(val) {
    //     return new Promise((resolve, reject) => {
    //         this.confPost.getEntityNameAndVersionAsCustomTypeWithParams(localStorage.getItem('partner'), localStorage.getItem('account'), val).subscribe(response => {
    //                 if (response.status === 200) {
    //                     this.entityAndVersion = response.body['entityNameAndVersion'];
    //                     resolve('success');
    //                 } else {
    //                     this.entityAndVersion = [];
    //                     resolve('failed');
    //                 }
    //             },
    //             error => {
    //                 this.entityAndVersion = [];
    //                 this.platform.handleErrorGracefully(error, 'Error while getting entity name and version for partner account. Please try again after sometime.');
    //                 resolve('success');
    //             });
    //     });
    // }


    async filterDataTypes(val) {
        this.getDatabaseTypeForDatabaseName(val);
        this.dataTypeFilter = [];
        this.datatypes.filter(items => {
            if (items.database_type === this.selectedDatatypeFilter) {
                this.dataTypeFilter.push(items);
            }
        });
        if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
            await this.platform.getCustomTypes(val);
            this.entityAndVersion = this.platform.entityAndVersion;
        } else {
            this.entityAndVersion = [];
        }
        if (this.entityAndVersion) {
            for (let i = 0; i < this.entityAndVersion.length; i++) {
                const newType = {
                    'database_type': 'mongodb',
                    'data_types': [
                        {
                            'type': this.entityAndVersion[i],
                            'default_length': '',
                            'min_length': '',
                            'max_length': ''
                        }]
                };
                this.dataTypeFilter.push(newType);
            }
        }
        if (this.selectedDatatypeFilter === 'mongodb') {
            this.tableLabelName = 'Collection Name';
        } else {
            this.tableLabelName = 'Table Name';
        }
    }

    getDatabaseTypeForDatabaseName(val) {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
                if (items.hasOwnProperty('is_nosql')) {
                    this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                }
            }
        });
    }

    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }

    displayVersion(version?: EntityVersions): string | undefined {
        return version ? version.name : undefined;
    }

    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData;
        const attributeName = clipboardData.getData('text');
        let attributeLength = 0;

        for (let i = 0; i < attributeName.length; i++) {
            if (attributeName.charCodeAt(i) === 8 || attributeName.charCodeAt(i) === 32 || (attributeName.charCodeAt(i) > 64 && attributeName.charCodeAt(i) < 91) || (attributeName.charCodeAt(i) > 96 && attributeName.charCodeAt(i) < 123) || (attributeName.charCodeAt(i) >= 48 && attributeName.charCodeAt(i) <= 57)) {
                attributeLength++;
            }
        }

        if (attributeLength !== attributeName.length) {
            this.isSpecialCharacterInAttribute = true;
        } else {
            this.isSpecialCharacterInAttribute = false;
        }

    }

    saveAPI() {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_save_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.dataAccessListenerInstance.dataAccessListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        const savePayload = {
            partner: '',
            account: '',
            executor_name: '',
            executor_type: '',
            by: '',
            executor_version: '',
            action: ''
        };

        savePayload.partner = this.partner;
        savePayload.account = this.account_id;
        savePayload['at'] = Date.now();
        savePayload.by = this.partner;

        if (this.entityName !== null && this.entityName !== undefined && this.entityName !== '') {
            savePayload.executor_name = this.entityName;
        } else {
            savePayload.executor_name = Date.now().toString();
        }

        savePayload.executor_version = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
        savePayload.action = 'CREATE';
        savePayload.executor_type = 'API';

        const crudAPI = {
            'entityname': this.entityName,
            'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': this.selectDatabase,
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'methods': methods,
            'attributes': this.apiByDefinition,
            'apiResponses': this.responseConfigurationsMethodWise,
            'referentialKeyConstraints': this.referentialKeyConstraints,
            'gatewayManagers': [this.selectedAPIGatewayName]
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        savePayload['executor'] = crudAPI;
        const temp = JSON.parse(JSON.stringify(savePayload['executor']));
        let isSame = true;
        if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
            if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                const keyArray = Object.keys(this.previousSavedData);
                for (const key of keyArray) {
                    if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                        continue;
                    } else {
                        isSame = false;
                        break;
                    }
                }
            } else {
                isSame = false;
            }
        } else {
            isSame = false;
        }

        if (isSame === false) {
            this.confPost.saveExecutorInformation('v1', savePayload).subscribe(data => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_save_success', 'INFO', data.status, data.statusText, '', crudAPI, data, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.dataAccessListenerInstance.dataAccessListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
            }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'dataaccessapi_create_save_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), crudAPI, error, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.dataAccessListenerInstance.dataAccessListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.handleErrorGracefully(error, 'Error while saving the API. Please try again after sometime.');
            });
        } else {
            this.platform.openSnackBar('No changes to save for this Data Access API.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    checkForExistingTables() {
        if (this.collectionTypeSelected === 'existing') {
            this.confPost.getDatabaseTables(this.partner, this.selectDatabase, this.selectedDatatypeFilter).subscribe(response => {
                this.existingTables = response;
            });
        }
    }

    resetDeployFlag() {
        this.invokingCheckForExistingTableFromDeploy = false;
    }

    resetTableName() {
        this.invokingCheckForExistingTableFromDeploy = true;
        this.tableName = '';
        this.previousTableName = '';
        if (this.collectionTypeSelected === 'new') {
            // this.reInitializeAPIDefinition();
            if (this.tableNameField && this.tableNameField !== undefined) {
                this.tableNameField.nativeElement.focus();
            }
        } else if (this.collectionTypeSelected === 'existing') {
            this.existingTablesLoading = true;
            this.confPost.getDatabaseTables(this.partner, this.selectDatabase, this.selectedDatatypeFilter).subscribe(response => {
                this.existingTables = response;
                this.existingTablesLoading = false;
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving the existing tables. Please try again after sometime.');
                this.collectionTypeSelected = 'new';
                // this.reInitializeAPIDefinition();
            });
            // this.existingTables = [
            //     'test', 'test1'
            // ];
        }
    }

    checkForExistingTableOnFocusOut() {
        // if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
        //   if (this.previousTableName !== this.tableName || this.previousSelectedDatatypeFilter !== this.selectedDatatypeFilter) {
        //     // this.reInitializeAPIDefinition();
        //   }
        // } else {
        //   // this.reInitializeAPIDefinition();
        // }
        // this.isAPIDefinitionImportedFromExistingTable = false;
        setTimeout(() => {
            if (this.invokingCheckForExistingTableFromDeploy === false) {
                this.checkForExistingTable();
            }
        }, 500);
    }

    getTableAttributes() {
        if (this.selectedDatatypeFilter !== 'default' && this.selectedDatatypeFilter !== 'mongodb') {
            return new Promise((resolve, reject) => {
                const deleteDialog1 = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                    data: {
                        message: 'Retrieving existing table attributes...'
                    }
                });
                this.confPost.getTableAttributes(this.partner, this.tableName, this.selectDatabase, this.selectedDatatypeFilter).subscribe(response1 => {
                    if (response1) {
                        this.isUseExistingTable = true;
                        this.collectionTypeSelected = 'existing';
                        this.isCheckForExistingTableCompleted = false;
                        deleteDialog1.close();
                        this.apiByDefinition = response1;
                        this.isAPIDefinitionImportedFromExistingTable = true;
                        this.previousTableName = this.tableName;
                        this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
                        resolve('success');
                    } else {
                        this.isUseExistingTable = false;
                        this.tableName = '';
                        this.platform.openSnackBar('Error while retrieving the existing table attributes. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.isCheckForExistingTableCompleted = false;
                        deleteDialog1.close();
                        // this.router.navigateByUrl('/controlplane');
                        this.collectionTypeSelected = 'new';
                    }
                }, error => {
                    this.tableName = '';
                    this.isUseExistingTable = false;
                    this.isCheckForExistingTableCompleted = false;
                    deleteDialog1.close();
                    this.platform.handleErrorGracefully(error, 'Error while retrieving the existing table attributes. Please try again after sometime.');
                    // this.router.navigateByUrl('/controlplane');
                    this.collectionTypeSelected = 'new';
                });
            });
        }
    }

    checkForExistingTableAndAttributes() {
        return new Promise((resolve, reject) => {
            const deleteDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confPost.checkIfTableExists(this.partner, this.tableName, this.selectDatabase, this.selectedDatatypeFilter).subscribe(response => {
                if (response && response !== undefined && response !== null) {
                    deleteDialog.close();
                    const dialogRef = this.dialog.open(UseExistingTableConfirmationComponent, {
                        width: 'auto',
                        height: 'auto',
                        data: {
                            message: 'Checking for table existence...'
                        }
                    });
                    dialogRef.afterClosed().subscribe(async result => {
                        if (result) {
                            if (result === 'yes') {
                                this.isUseExistingTable = true;
                                await this.getTableAttributes();
                                resolve('success');
                            } else {
                                this.isUseExistingTable = false;
                                this.tableName = '';
                                if (this.tableNameField && this.tableNameField !== undefined) {
                                    this.tableNameField.nativeElement.focus();
                                }
                                if (this.tableNameField1 && this.tableNameField1 !== undefined) {
                                    this.tableNameField1.nativeElement.focus();
                                }
                                this.isCheckForExistingTableCompleted = false;
                                resolve('success');
                            }
                        } else {
                            this.isUseExistingTable = false;
                            this.tableName = '';
                            if (this.tableNameField && this.tableNameField !== undefined) {
                                this.tableNameField.nativeElement.focus();
                            }
                            if (this.tableNameField1 && this.tableNameField1 !== undefined) {
                                this.tableNameField1.nativeElement.focus();
                            }
                            this.isCheckForExistingTableCompleted = false;
                            resolve('success');
                        }
                    });
                } else {
                    this.isUseExistingTable = false;
                    this.previousTableName = this.tableName;
                    this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
                    this.isCheckForExistingTableCompleted = false;
                    resolve('success');
                    deleteDialog.close();
                }

            }, error => {
                deleteDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while checking the existing tables in your account. Please try again after sometime.');
                this.router.navigateByUrl('/controlplane');
            });
        });
    }

    checkForExistingTable() {
        return new Promise(async (resolve, reject) => {
            if (this.tableName !== undefined && this.selectedDatatypeFilter !== undefined) {
                if (this.isCheckForExistingTableCompleted === false) {
                    if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
                        if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {
                            if (this.tableName !== undefined && this.tableName !== '' && this.tableName !== null && this.selectedDatatypeFilter !== undefined && this.selectedDatatypeFilter !== '' && this.selectedDatatypeFilter !== null) {
                                if (this.tableName !== this.previousTableName || this.selectedDatatypeFilter !== this.previousSelectedDatatypeFilter) {
                                    this.isCheckForExistingTableCompleted = true;
                                    await this.checkForExistingTableAndAttributes();
                                    resolve('success');
                                }
                            }
                        }
                    } else {
                        if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {
                            if (this.tableName !== undefined && this.tableName !== '' && this.tableName !== null && this.selectedDatatypeFilter !== undefined && this.selectedDatatypeFilter !== '' && this.selectedDatatypeFilter !== null) {
                                this.isCheckForExistingTableCompleted = true;
                                await this.checkForExistingTableAndAttributes();
                                resolve('success');
                            }
                        }
                    }
                } else {
                    resolve('success');
                }
            }
        });
    }

    checkForExistingEntityAndExecutorFromFocusOut() {
        this.emitMethodType();
        setTimeout(() => {
            this.checkForExistingEntityAndExecutor();
        }, 500);
    }

    CheckForExistingEntityOrExecutor() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.entityName, this.version)).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = this.entityName;
                this.previouslyCheckedVersion = this.version;
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.entityName;
                        this.previouslyCheckedVersion = this.version;
                        resolve('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.entityName;
                        this.previouslyCheckedVersion = this.version;
                        resolve('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor() {
        return new Promise(async (resolve, reject) => {
            if (this.entityName !== null && this.entityName !== undefined && this.entityName !== '' && this.version !== null && this.version !== undefined && this.version !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.previouslyCheckedName !== this.entityName || this.previouslyCheckedVersion !== this.version) {
                            this.isAPIAlreadyPresentCheckCompleted = true;
                            await this.CheckForExistingEntityOrExecutor();
                            resolve('success');
                        } else {
                            resolve('success');
                        }
                    } else {
                        this.isAPIAlreadyPresentCheckCompleted = true;
                        await this.CheckForExistingEntityOrExecutor();
                        resolve('success');
                    }
                } else {
                    resolve('success');
                }
            } else {
                resolve('Failure');
            }
        });
    }

    setRequired(definition, event) {
        definition['required'] = event['checked'];
    }

    listenAPICreation(timestamp, apiName, apiVersion, action) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, action).subscribe(data => {
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                }
            });
        }
    }

    displaySnackBarWithWS(type, duration, msg) {
        if (!this.websocketService.isOpen()) {
            this.platform.openSnackBar(msg, type, {
                duration: duration,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    closeLogPanel() {
        this.logVisible = false;
        this.confPost.getEntityForPartner(this.partner, this.account_id, this.partnerKey, this.entityName, this.version).subscribe(response => {
            if (response !== null && response !== undefined) {
                this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            }
        });
    }


    async createApi2() {
        this.currentMessage = '';
        const timeStamp = Date.now();
        if (this.websocketService.checkConnection()) {
            this.connection = true;
        } else {
            this.connection = false;
        }
        this.action = 'deploy';
        this.entityName = this.entityName;
        this.version = this.version;
        this.listenAPICreation(timeStamp, this.entityName, this.version, this.action);
        this.logVisible = true;
        this.logComponentRefresh = true;
        let apiexistRes: any;
        if (this.isAPIAlreadyPresentCheckCompleted === false) {
            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                info: 'Checking for API existence',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            apiexistRes = await this.checkForExistingEntityAndExecutor();

        }
        if (apiexistRes === 'success') {
            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                info: 'Checking for API existence',
                type: 'success',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                info: 'Checking for database table',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {
                if (this.isCheckForExistingTableCompleted === false) {
                    this.invokingCheckForExistingTableFromDeploy = true;
                    if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
                        if (this.previousTableName !== this.tableName || this.previousSelectedDatatypeFilter !== this.selectedDatatypeFilter) {
                            await this.checkForExistingTableAndAttributes();
                            this.invokingCheckForExistingTableFromDeploy = false;
                        }
                    } else {
                        await this.checkForExistingTableAndAttributes();
                        this.invokingCheckForExistingTableFromDeploy = false;
                    }
                }
            }
            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                info: 'Checking for database table',
                type: 'success',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                info: 'Checking for special characters',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.entityName)).then(resp1 => {
                if (resp1 === true) {
                    Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.version)).then(resp2 => {
                        if (resp2 === true) {
                            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_deploy_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
                                const payloadToSend = {
                                    actions: response1
                                };
                                this.dataAccessListenerInstance.dataAccessListener.emit({
                                    type: 'audit',
                                    id: localStorage.getItem('IdOfSession'),
                                    payload: payloadToSend
                                });
                            });
                            const temparray = [];
                            for (let i = 0; i < this.apiByDefinition.length; i++) {
                                if (this.apiByDefinition[i]['attributeName'] !== null && this.apiByDefinition[i]['type'] !== null) {
                                    temparray.push(this.apiByDefinition[i]);
                                }
                            }
                            this.apiByDefinition = temparray;

                            // if ((this.partnerEntities.filter(element => element.entityname === this.entityName)).length === 0) {
                            //     if ((this.partnerExecutors.filter(element => element.executor_name === this.entityName)).length === 0) {
                            //         this.isAPIAlreadyPresent = false;
                            //     } else {
                            //         if ((this.partnerExecutors.filter(element => (element.executor_version === this.version && element.executor_name === this.entityName))).length === 0) {
                            //             this.isAPIAlreadyPresent = false;
                            //         } else {
                            //             this.isAPIAlreadyPresent = true;
                            //         }
                            //     }
                            // } else {
                            //     if ((this.partnerEntities.filter(element => (element.version === this.version && element.entityname === this.entityName))).length === 0) {
                            //         this.isAPIAlreadyPresent = false;
                            //     } else {
                            //         this.isAPIAlreadyPresent = true;
                            //     }
                            // }

                            // if ((this.partnerEntities.filter(element => (element.entityname === this.entityName && element.version === this.version)).length === 0)) {
                            //     if ((this.partnerExecutors.filter(element => (element.executor_name === this.entityName && element.executor_version === this.version)).length === 0)) {
                            //         this.isAPIAlreadyPresent = false;
                            //     } else {
                            //         this.isAPIAlreadyPresent = true;
                            //     }
                            // } else {
                            //     this.isAPIAlreadyPresent = true;
                            // }

                            if (this.apiByDefinition.length === 0) {
                                // alert('Please add schema definition');
                                // this.platform.openSnackBar('Please define schema under Schema Definition', 'Error', {
                                //   duration: 10000,
                                //   verticalPosition: 'top',
                                //   horizontalPosition: 'center'
                                // });

                                this.displaySnackBarWithWS('Error', 5000, 'Please define schema under Schema Definition');
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                    info: 'Checking for special characters',
                                    type: 'fatal',
                                    icon: 'fa fa-newspaper-o',
                                    description: 'Please define schema under Schema Definition'
                                }, timeStamp, 'deploy');


                            } else if (this.tableName === undefined || this.tableName === null || this.tableName === '') {
                                // this.platform.openSnackBar('Please provide a ' + this.tableLabelName + ' to create an API', 'Error', {
                                //   duration: 10000,
                                //   verticalPosition: 'top',
                                //   horizontalPosition: 'center'
                                // });
                                this.displaySnackBarWithWS('Error', 5000, 'Please provide a ' + this.tableLabelName + ' to create an API');
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                    info: 'Checking for special characters',
                                    type: 'fatal',
                                    icon: 'fa fa-newspaper-o',
                                    description: 'Please provide a ' + this.tableLabelName + ' to create an API'
                                }, timeStamp, 'deploy');

                            } else if (this.isAPIAlreadyPresent === true) {
                                // this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                //   duration: 10000,
                                //   verticalPosition: 'top',
                                //   horizontalPosition: 'center'
                                // });
                                this.displaySnackBarWithWS('Error', 5000, 'An API with the provided name and version already exists.');
                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                    info: 'Checking for special characters',
                                    type: 'fatal',
                                    icon: 'fa fa-newspaper-o',
                                    description: 'An API with the provided name and version already exists.'
                                }, timeStamp, 'deploy');

                            } else {
                                const vers = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
                                if (this.entityName !== undefined && this.entityName !== null && this.entityName.length !== 0 &&
                                    vers !== undefined && vers !== null && vers.length !== 0 &&
                                    this.apiCategory !== undefined && this.apiCategory !== null && this.apiCategory.length !== 0 &&
                                    this.methodType !== undefined && this.methodType !== null && this.methodType.length !== 0 &&
                                    this.selectDatabase !== undefined && this.selectDatabase !== null && this.selectDatabase.length !== 0 &&
                                    this.apiByDefinition[0].attributeName !== null) {

                                    this.save = false;
                                    const that = this;
                                    let entityLength = 0;
                                    let versionLength = 0;

                                    for (let i = 0; i < this.entityName.length; i++) {
                                        if (this.entityName.charCodeAt(i) === 8 || this.entityName.charCodeAt(i) === 32 || (this.entityName.charCodeAt(i) > 64 && this.entityName.charCodeAt(i) < 91) || (this.entityName.charCodeAt(i) > 96 && this.entityName.charCodeAt(i) < 123) || (this.entityName.charCodeAt(i) >= 48 && this.entityName.charCodeAt(i) <= 57)) {
                                            entityLength++;
                                        }
                                    }

                                    for (let i = 0; i < this.version.length; i++) {
                                        if (this.version.charCodeAt(i) === 8 || this.version.charCodeAt(i) === 32 || (this.version.charCodeAt(i) > 64 && this.version.charCodeAt(i) < 91) || (this.version.charCodeAt(i) > 96 && this.version.charCodeAt(i) < 123) || (this.version.charCodeAt(i) >= 48 && this.version.charCodeAt(i) <= 57)) {
                                            versionLength++;
                                        }
                                    }

                                    if (this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95) {
                                        this.isValidTableName = true;
                                    }
                                    this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                        info: 'Checking for special characters',
                                        type: 'success',
                                        icon: 'fa fa-newspaper-o'
                                    }, timeStamp, 'deploy');
                                    const methods = [];
                                    if (this.ispublished) {
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Preparing for API methods',
                                            type: 'initial',
                                            icon: 'fa fa-newspaper-o'
                                        }, timeStamp, 'deploy');
                                        this.methodType.forEach(method => {
                                            methods.push(method.id);
                                        });
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Preparing for API methods',
                                            type: 'success',
                                            icon: 'fa fa-newspaper-o'
                                        }, timeStamp, 'deploy');
                                        this.apigatewayInstance.methodTypeListener.emit({
                                            methodType: methods,
                                            entityName: this.entityName,
                                            version: this.version,
                                            isEdit: false,
                                            selectedGatewayObject: this.selectedAPIGateway
                                        });
                                    } else {
                                        this.scopeSelected = 'private';
                                    }
                                    if (entityLength === this.entityName.length) {
                                        if (versionLength === this.version.length) {
                                            if (this.isValidTableName) {
                                                // if (!this.isSpecialCharacterInAttribute) {
                                                this.platform.publishEventMessage(this.entityName, this.version,
                                                    environment.pubsubtitles.API_DESIGN, {
                                                        info: 'Reading schema from API design',
                                                        type: 'initial',
                                                        icon: 'fa fa-file-code-o'
                                                    }, timeStamp, 'deploy');
                                                this.loading = true;
                                                const crudAPI = {
                                                    'entityname': this.entityName,
                                                    'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
                                                    'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                                                    'displayname': this.displayName,
                                                    'description': this.description,
                                                    'published': this.ispublished,
                                                    'scopeOfAccess': this.scopeSelected,
                                                    'creationTime': Date.now(),
                                                    'lastModifiedTime': Date.now(),
                                                    'registeredAsIs': false,
                                                    'database': this.selectDatabase,
                                                    'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                                                    'methods': methods,
                                                    'attributes': this.apiByDefinition,
                                                    'apiResponses': this.responseConfigurationsMethodWise,
                                                    'referentialKeyConstraints': this.referentialKeyConstraints,
                                                    'gatewayManagers': [this.selectedAPIGatewayName]
                                                };
                                                if (this.isUseExistingTable === true) {
                                                    crudAPI['tableCreation'] = false;
                                                } else {
                                                    crudAPI['tableCreation'] = true;
                                                }
                                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                                                    info: 'Reading schema from API design',
                                                    type: 'success',
                                                    icon: 'fa fa-file-code-o'
                                                }, timeStamp, 'deploy');
                                                this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DEVELOPMENT, {
                                                    info: 'Generating code for the schema',
                                                    type: 'initial',
                                                    icon: 'fa fa-edit'
                                                }, timeStamp, 'deploy');
                                                if (this.ispublished) {
                                                    if (this.selectedAPIGateway && this.selectedAPIGateway.hasOwnProperty('status') && this.selectedAPIGateway['status'] === true) {
                                                        let isPathEmpty = false;
                                                        let emptyPathIndex = 0;
                                                        for (let i = 0; i < this.apigatewayInstance.gatewayRoute.data.length; i++) {
                                                            const route = this.apigatewayInstance.gatewayRoute.data[i];
                                                            if (route && route !== null && route !== undefined) {
                                                                if (route.paths.length === 0) {
                                                                    emptyPathIndex = i;
                                                                    isPathEmpty = true;
                                                                }
                                                            }
                                                        }
                                                        if (isPathEmpty === true) {
                                                            if (confirm('You haven\'t specified any paths in your route(s). Do you want to create a default path ' + '\'/' + this.version + '/' + this.entityName + '\' ?')) {
                                                                for (let i = 0; i < this.apigatewayInstance.gatewayRoute.data.length; i++) {
                                                                    const route = this.apigatewayInstance.gatewayRoute.data[i];
                                                                    if (route && route !== null && route !== undefined) {
                                                                        if (route.paths.length === 0) {
                                                                            this.apigatewayInstance.gatewayRoute.data[i].paths[0] = '/' + this.version + '/' + this.entityName;
                                                                        }
                                                                    }
                                                                }
                                                                // this.apigatewayInstance.gatewayRoute.data[emptyPathIndex].paths[0] = '/' + this.version + '/' + this.entityName;
                                                                Promise.resolve(this.configureAPIGatewaySettingsWithMethods(timeStamp)).then(gatewayResponse => {
                                                                    this.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI, timeStamp);
                                                                }, error => {
                                                                    this.loading = false;
                                                                    that.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
                                                                });
                                                            } else {
                                                                this.loading = false;
                                                            }
                                                        } else {
                                                            Promise.resolve(this.configureAPIGatewaySettingsWithMethods(timeStamp)).then(gatewayResponse => {
                                                                this.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI, timeStamp);
                                                            }, error => {
                                                                this.loading = false;
                                                                that.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
                                                            });
                                                        }
                                                    } else {
                                                        this.platform.openSnackBar('The selected API Gateway is disabled. Please enable this API Gateway in the admin settings or deploy with different API Gateway', 'Error', {
                                                            duration: 5000,
                                                            verticalPosition: 'top',
                                                            horizontalPosition: 'center'
                                                        });
                                                    }
                                                } else {
                                                    this.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI, timeStamp);
                                                }
                                                // if (this.ispublished) {
                                                //     // this.configureApiGateway();
                                                //     this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false, methods);
                                                // }

                                                // } else {
                                                //     this.platform.openSnackBar('Special characters are not allowed in attribute name', 'Error', {
                                                //         duration: 5000,
                                                //         verticalPosition: 'top',
                                                //         horizontalPosition: 'center'
                                                //     });
                                                // }
                                            } else {
                                                this.platform.openSnackBar('Special characters are not allowed at the beginning of a table name.', 'Error', {
                                                    duration: 5000,
                                                    verticalPosition: 'top',
                                                    horizontalPosition: 'center'
                                                });
                                            }
                                        } else {
                                            this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
                                                duration: 5000,
                                                verticalPosition: 'top',
                                                horizontalPosition: 'center'
                                            });
                                        }
                                    } else {
                                        this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                } else {

                                    if (this.entityName === undefined || this.entityName === '' || this.entityName === null || this.entityName.length === 0) {
                                        // this.platform.openSnackBar('Please enter a valid name for Data Access Service', 'Error', {
                                        //     duration: 5000,
                                        //     verticalPosition: 'top',
                                        //     horizontalPosition: 'center'
                                        // });

                                        // this.platform.openSnackBar('Please enter a valid name for Data Access Service.', 'Error', null);
                                        this.displaySnackBarWithWS('Error', 5000, 'Please enter a valid name for Data Access Service.');
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Checking for special characters',
                                            type: 'fatal',
                                            icon: 'fa fa-newspaper-o',
                                            description: 'Please enter a valid name for Data Access Service.'
                                        }, timeStamp, 'deploy');
                                    } else if (vers === undefined || vers === '' || vers === null || vers === 0) {
                                        this.displaySnackBarWithWS('Error', 5000, 'Please enter a valid version for Data Access Service.');
                                        // this.platform.openSnackBar('Please enter a valid version for Data Access Service', 'Error', {
                                        //   duration: 5000,
                                        //   verticalPosition: 'top',
                                        //   horizontalPosition: 'center'
                                        // });
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Checking for special characters',
                                            type: 'fatal',
                                            icon: 'fa fa-newspaper-o',
                                            description: 'Please enter a valid name for Data Access Service.'
                                        }, timeStamp, 'deploy');
                                    } else if (this.apiCategory === undefined || this.apiCategory === '' || this.apiCategory === null || this.apiCategory.length === 0) {
                                        this.displaySnackBarWithWS('Error', 5000, 'Please enter a valid category for Data Access Service.');
                                        // this.platform.openSnackBar('Please enter a valid category for Data Access Service', 'Error', {
                                        //   duration: 5000,
                                        //   verticalPosition: 'top',
                                        //   horizontalPosition: 'center'
                                        // });
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Checking for special characters',
                                            type: 'fatal',
                                            icon: 'fa fa-newspaper-o',
                                            description: 'Please enter a valid category for Data Access Service'
                                        }, timeStamp, 'deploy');
                                    } else if (this.selectDatabase === undefined || this.selectDatabase === null || this.selectDatabase.length === 0) {
                                        // this.platform.openSnackBar('Please select a database to create this service', 'Error', {
                                        //   duration: 5000,
                                        //   verticalPosition: 'top',
                                        //   horizontalPosition: 'center'
                                        // });
                                        this.displaySnackBarWithWS('Error', 5000, 'Please select a database to create this service.');
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Checking for special characters',
                                            type: 'fatal',
                                            icon: 'fa fa-newspaper-o',
                                            description: 'Please select a database to create this service'
                                        }, timeStamp, 'deploy');
                                    } else if (this.methodType === undefined || this.methodType === [] || this.methodType === null || this.methodType.length === 0) {
                                        // this.platform.openSnackBar('You need to select at least one Method Type to create this service', 'Error', {
                                        //   duration: 5000,
                                        //   verticalPosition: 'top',
                                        //   horizontalPosition: 'center'
                                        // });
                                        this.displaySnackBarWithWS('Error', 5000, 'You need to select at least one Method Type to create this service.');
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Checking for special characters',
                                            type: 'fatal',
                                            icon: 'fa fa-newspaper-o',
                                            description: 'You need to select at least one Method Type to create this service'
                                        }, timeStamp, 'deploy');
                                    } else if (this.apiByDefinition[0].attributeName === null) {
                                        // this.platform.openSnackBar('You need to select at least one Attribute to create this service', 'Error', {
                                        //   duration: 5000,
                                        //   verticalPosition: 'top',
                                        //   horizontalPosition: 'center'
                                        // });
                                        this.displaySnackBarWithWS('Error', 5000, 'You need to select at least one Attribute to create this service.');
                                        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                                            info: 'Checking for special characters',
                                            type: 'fatal',
                                            icon: 'fa fa-newspaper-o',
                                            description: 'You need to select at least one Attribute to create this service'
                                        }, timeStamp, 'deploy');
                                    }
                                }
                            }
                        } else {
                            this.loading = false;
                            this.platform.openSnackBar('Executor version should not have any special characters or spaces in between', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    });
                } else {
                    this.loading = false;
                    this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                        info: 'Checking for special characters',
                        type: 'fatal',
                        icon: 'fa fa-newspaper-o',
                        description: 'Executor name should not have any special characters or spaces in between'
                    }, timeStamp, 'deploy');
                    // this.platform.openSnackBar('Executor name should not have any special characters or spaces in between', 'Error', {
                    //   duration: 10000,
                    //   verticalPosition: 'top',
                    //   horizontalPosition: 'center'
                    // });
                    this.displaySnackBarWithWS('Error', 5000, 'Executor name should not have any special characters or spaces in between.');
                }
            });
        } else {
            this.displaySnackBarWithWS('Error', 5000, 'An API with provided name and version already exists.');
            this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_REQUIREMENTS, {
                info: 'Checking for API existence',
                type: 'fatal',
                icon: 'fa fa-newspaper-o',
                description: 'Invalid API Name and Version'
            }, timeStamp, 'deploy');
        }

    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
        if (!this.connection) {
            this.logVisible = true;
            this.refreshLogCount++;
        }
    }

    async createApi() {
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;
        this.logVisible = false;
        if (this.websocketService.isOpen()) {
            this.connection = true;
            // this.logVisible = true;
        } else {
            this.connection = false;
        }
        this.action = 'deploy';
        this.entityName = this.entityName;
        this.version = this.version;
        this.loading = true;
        this.listenAPICreation(timeStamp, this.entityName, this.version, this.action);

        let setDefaultPath = false;


        this.logComponentRefresh = true;

        const vers = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
        const category = ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory);
        const entityValidate = {
            'entityName': this.entityName,
            'apiCategory': category,
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayName': this.displayName,
            'description': this.description,
            'selectDatabase': this.selectDatabase,
            'version': vers,
            'methods': this.methodType,
            'apiByDefinition': this.apiByDefinition,
            'timeStamp': timeStamp,
            'action': this.action
        };

        if (this.entityName !== undefined && this.entityName !== null && this.entityName.length !== 0 &&
            vers !== undefined && vers !== null && vers !== 0 &&
            category !== undefined && category !== null && category.length !== 0 &&
            this.methodType !== undefined && this.methodType !== null && this.methodType.length !== 0 &&
            this.selectDatabase !== undefined && this.selectDatabase !== null && this.selectDatabase.length !== 0 &&
            this.apiByDefinition && this.apiByDefinition.length && this.apiByDefinition[0].attributeName !== null &&
            this.tableName !== undefined && this.tableName !== null && this.tableName.length !== 0 &&
            (this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95)) {

            await this.CheckForExistingEntityOrExecutor();

            if (this.isAPIAlreadyPresent) {
                this.loading = false;
                this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                this.loading = true;
                if (this.connection === false) {
                    this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                        data: {
                            message: 'API deployment is under progress. Please don\'t close the window'
                        }
                    });
                } else {
                    this.logVisible = true;
                }

                    const temparray = [];
                    for (let i = 0; i < this.apiByDefinition.length; i++) {
                      if (this.apiByDefinition[i]['attributeName'] !== null && this.apiByDefinition[i]['type'] !== null) {
                        temparray.push(this.apiByDefinition[i]);
                      }
                    }
                    this.apiByDefinition = temparray;

                    const methods = [];
                      this.methodType.forEach(method => {
                        methods.push(method.id);
                      });
                const crudAPI = {
                    'entityname': this.entityName,
                    'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
                    'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                    'displayname': this.displayName,
                    'description': this.description,
                    'published': this.ispublished,
                    'scopeOfAccess': this.scopeSelected,
                    'creationTime': Date.now(),
                    'lastModifiedTime': Date.now(),
                    'registeredAsIs': false,
                    'database': this.selectDatabase,
                    'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                    'methods': methods,
                    'attributes': this.apiByDefinition,
                    'apiResponses': this.responseConfigurationsMethodWise,
                    'referentialKeyConstraints': this.referentialKeyConstraints,
                    'gatewayManagers': [this.selectedAPIGatewayName]
                };
                if (this.isUseExistingTable === true) {
                    crudAPI['tableCreation'] = false;
                } else {
                    crudAPI['tableCreation'] = true;
                }

                const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('account') + '.' + this.entityName + '.' + this.version + '.' + localStorage.getItem('sessionID') + '.' + timeStamp.toString() + '.' + this.action;

                const crudApi1 = {
                    'topic': topic,
                    'apiModel': crudAPI
                };
                this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), crudApi1, true, false, true, true).toPromise().then(response => {

                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                        this.loading = false;
                        if (this.showDialogOnNonWebsocketConnection) {
                            this.showDialogOnNonWebsocketConnection.close();
                        }
                        if (!this.websocketService.isOpen()) {
                            this.logVisible = true;
                            this.refreshLogCount++;
                        }
                        const log_payload = {
                            logType: 'INFO',
                            logLevel: 2,
                            slugSearch: '',
                            label: 'BUTTON_CLICK',
                            featureArea: this.platform.auditFeatureArea.daasAdvanced,
                            resource: 'DEPLOY',
                            action: 'CLICK',
                            result: 'SUCCESS',
                            payload: crudApi1,
                            responseStatusCode: 200,
                            response: response,
                            errorMessage: '',
                            logMessage: 'API deployed'
                        };
                        this.auditLog.log(log_payload);
                    },
                    error => {

                        this.loading = false;
                        if (this.showDialogOnNonWebsocketConnection) {
                            this.showDialogOnNonWebsocketConnection.close();
                        }
                        if (!this.websocketService.isOpen()) {
                            this.logVisible = true;
                            this.refreshLogCount++;
                        }
                        const log_payload = {
                            logType: 'INFO',
                            logLevel: 2,
                            slugSearch: '',
                            label: 'BUTTON_CLICK',
                            featureArea: this.platform.auditFeatureArea.daasAdvanced,
                            resource: 'DEPLOY',
                            action: 'CLICK',
                            result: 'FAIL',
                            payload: crudApi1,
                            responseStatusCode: error.status,
                            response: error,
                            errorMessage: error.message,
                            logMessage: 'Error in API deployment'
                        };
                        this.auditLog.log(log_payload);
                    });

                // this.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI, timeStamp);
                // Promise.resolve(this.apiCreatorService.validateDaas(entityValidate, timeStamp, this.action)).then(async resp1 => {
                //
                //   // console.log('validate daasa:'+resp1)
                //   if (resp1 === 'success') {
                //     if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {
                //       if (this.isCheckForExistingTableCompleted === false) {
                //         this.invokingCheckForExistingTableFromDeploy = true;
                //         if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
                //           if (this.previousTableName !== this.tableName || this.previousSelectedDatatypeFilter !== this.selectedDatatypeFilter) {
                //             await this.checkForExistingTableAndAttributes();
                //             this.invokingCheckForExistingTableFromDeploy = false;
                //           }
                //         } else {
                //           await this.checkForExistingTableAndAttributes();
                //           this.invokingCheckForExistingTableFromDeploy = false;
                //         }
                //       }
                //     }
                //
                //     Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_deploy_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
                //       const payloadToSend = {
                //         actions: response1
                //       };
                //       this.dataAccessListenerInstance.dataAccessListener.emit({
                //         type: 'audit',
                //         id: localStorage.getItem('IdOfSession'),
                //         payload: payloadToSend
                //       });
                //     });
                //     const temparray = [];
                //     for (let i = 0; i < this.apiByDefinition.length; i++) {
                //       if (this.apiByDefinition[i]['attributeName'] !== null && this.apiByDefinition[i]['type'] !== null) {
                //         temparray.push(this.apiByDefinition[i]);
                //       }
                //     }
                //     this.apiByDefinition = temparray;
                //
                //     // if ((this.partnerEntities.filter(element => element.entityname === this.entityName)).length === 0) {
                //     //     if ((this.partnerExecutors.filter(element => element.executor_name === this.entityName)).length === 0) {
                //     //         this.isAPIAlreadyPresent = false;
                //     //     } else {
                //     //         if ((this.partnerExecutors.filter(element => (element.executor_version === this.version && element.executor_name === this.entityName))).length === 0) {
                //     //             this.isAPIAlreadyPresent = false;
                //     //         } else {
                //     //             this.isAPIAlreadyPresent = true;
                //     //         }
                //     //     }
                //     // } else {
                //     //     if ((this.partnerEntities.filter(element => (element.version === this.version && element.entityname === this.entityName))).length === 0) {
                //     //         this.isAPIAlreadyPresent = false;
                //     //     } else {
                //     //         this.isAPIAlreadyPresent = true;
                //     //     }
                //     // }
                //
                //     // if ((this.partnerEntities.filter(element => (element.entityname === this.entityName && element.version === this.version)).length === 0)) {
                //     //     if ((this.partnerExecutors.filter(element => (element.executor_name === this.entityName && element.executor_version === this.version)).length === 0)) {
                //     //         this.isAPIAlreadyPresent = false;
                //     //     } else {
                //     //         this.isAPIAlreadyPresent = true;
                //     //     }
                //     // } else {
                //     //     this.isAPIAlreadyPresent = true;
                //     // }
                //
                //
                //     // const vers = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
                //
                //     this.save = false;
                //     const that = this;
                //     let entityLength = 0;
                //     let versionLength = 0;
                //
                //     for (let i = 0; i < this.entityName.length; i++) {
                //       if (this.entityName.charCodeAt(i) === 8 || this.entityName.charCodeAt(i) === 32 || (this.entityName.charCodeAt(i) > 64 && this.entityName.charCodeAt(i) < 91) || (this.entityName.charCodeAt(i) > 96 && this.entityName.charCodeAt(i) < 123) || (this.entityName.charCodeAt(i) >= 48 && this.entityName.charCodeAt(i) <= 57)) {
                //         entityLength++;
                //       }
                //     }
                //
                //     for (let i = 0; i < this.version.length; i++) {
                //       if (this.version.charCodeAt(i) === 8 || this.version.charCodeAt(i) === 32 || (this.version.charCodeAt(i) > 64 && this.version.charCodeAt(i) < 91) || (this.version.charCodeAt(i) > 96 && this.version.charCodeAt(i) < 123) || (this.version.charCodeAt(i) >= 48 && this.version.charCodeAt(i) <= 57)) {
                //         versionLength++;
                //       }
                //     }
                //
                //     if (this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95) {
                //       this.isValidTableName = true;
                //     }
                //     // this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_REQUIREMENTS, {info: 'Checking for special characters', type: 'success', icon : 'fa fa-newspaper-o'}, timeStamp, 'deploy');
                //     const methods = [];
                //     if (this.ispublished) {
                //       this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                //         info: 'Preparing for API methods',
                //         type: 'initial',
                //         icon: 'fa fa-newspaper-o'
                //       }, timeStamp, 'deploy');
                //       this.methodType.forEach(method => {
                //         methods.push(method.id);
                //       });
                //       this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                //         info: 'Preparing for API methods',
                //         type: 'success',
                //         icon: 'fa fa-newspaper-o'
                //       }, timeStamp, 'deploy');
                //       // this.apigatewayInstance.methodTypeListener.emit({methodType: methods, entityName: this.entityName, version: this.version, isEdit: false,  selectedGatewayObject: this.selectedAPIGateway});
                //       this.emitMethodType();
                //     } else {
                //       this.scopeSelected = 'private';
                //     }
                //     if (entityLength === this.entityName.length) {
                //       if (versionLength === this.version.length) {
                //         if (this.isValidTableName) {
                //           // if (!this.isSpecialCharacterInAttribute) {
                //           this.platform.publishEventMessage(this.entityName, this.version,
                //               environment.pubsubtitles.API_DESIGN, {
                //                 info: 'Reading schema from API design',
                //                 type: 'initial',
                //                 icon: 'fa fa-file-code-o'
                //               }, timeStamp, 'deploy');
                //           this.loading = true;
                //
                //           const crudAPI = {
                //             'entityname': this.entityName,
                //             'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
                //             'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                //             'displayname': this.displayName,
                //             'description': this.description,
                //             'published': this.ispublished,
                //             'scopeOfAccess': this.scopeSelected,
                //             'creationTime': Date.now(),
                //             'lastModifiedTime': Date.now(),
                //             'registeredAsIs': false,
                //             'database': this.selectDatabase,
                //             'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                //             'methods': methods,
                //             'attributes': this.apiByDefinition,
                //             'apiResponses': this.responseConfigurationsMethodWise,
                //             'referentialKeyConstraints': this.referentialKeyConstraints,
                //             'gatewayManagers': [this.selectedAPIGatewayName]
                //           };
                //           if (this.isUseExistingTable === true) {
                //             crudAPI['tableCreation'] = false;
                //           } else {
                //             crudAPI['tableCreation'] = true;
                //           }
                //           console.log('Payload',crudAPI);
                //           this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DESIGN, {
                //             info: 'Reading schema from API design',
                //             type: 'success',
                //             icon: 'fa fa-file-code-o'
                //           }, timeStamp, 'deploy');
                //           await this.platform.delay(500);
                //           this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DEVELOPMENT, {
                //             info: 'Generating code for the schema',
                //             type: 'initial',
                //             icon: 'fa fa-edit'
                //           }, timeStamp, 'deploy');
                //           await this.platform.delay(500);
                //           this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DEVELOPMENT, {
                //             info: 'Generating code for the schema',
                //             type: 'success'
                //           }, timeStamp, 'deploy');
                //           if (this.ispublished) {
                //             if (this.selectedAPIGateway && this.selectedAPIGateway.hasOwnProperty('status') && this.selectedAPIGateway['status'] === true) {
                //               let isPathEmpty = false;
                //               let emptyPathIndex = 0;
                //               for (let i = 0; i < this.apigatewayInstance.gatewayRoute.data.length; i++) {
                //                 const route = this.apigatewayInstance.gatewayRoute.data[i];
                //                 if (route && route !== null && route !== undefined) {
                //                   if (route.paths.length === 0) {
                //                     emptyPathIndex = i;
                //                     isPathEmpty = true;
                //                   }
                //                 }
                //               }
                //               if (isPathEmpty === true) {
                //                 if (confirm('You haven\'t specified any paths in your route(s). Do you want to create a default path ' + '\'/' + this.version + '/' + this.entityName + '\' ?')) {
                //                   for (let i = 0; i < this.apigatewayInstance.gatewayRoute.data.length; i++) {
                //                     const route = this.apigatewayInstance.gatewayRoute.data[i];
                //                     if (route && route !== null && route !== undefined) {
                //                       if (route.paths.length === 0) {
                //                         this.apigatewayInstance.gatewayRoute.data[i].paths[0] = '/' + this.version + '/' + this.entityName;
                //                       }
                //                     }
                //                   }
                //                   // this.apigatewayInstance.gatewayRoute.data[emptyPathIndex].paths[0] = '/' + this.version + '/' + this.entityName;
                //                   Promise.resolve(this.configureAPIGatewaySettingsWithMethods(timeStamp)).then(gatewayResponse => {
                //                     this.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI, timeStamp);
                //                   }, error => {
                //                     Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', crudAPI, error.status, '', '', error.statusText)).then(response => {
                //                       this.auditListenerService.auditListener.emit({
                //                         type: 'auditLog',
                //                         category: 'isAuditForDataAccessAdvanced',
                //                         payload: response
                //                       });
                //                     });
                //                     this.loading = false;
                //                     this.closeNonWSDialogBox();
                //                     that.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
                //                   });
                //                 } else {
                //                   this.loading = false;
                //                   this.logVisible = false;
                //                   if (this.showDialogOnNonWebsocketConnection) {
                //                     this.showDialogOnNonWebsocketConnection.close();
                //                   }
                //
                //                   Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', crudAPI, 400, '', '', 'Paths not specified')).then(response => {
                //                     this.auditListenerService.auditListener.emit({
                //                       type: 'auditLog',
                //                       category: 'isAuditForDataAccessAdvanced',
                //                       payload: response
                //                     });
                //                   });
                //                   this.platform.openSnackBar('Please specify paths for the routes to proceed with the deployment.', 'Error', {
                //                     duration: 5000,
                //                     verticalPosition: 'top',
                //                     horizontalPosition: 'center'
                //                   });
                //                 }
                //               } else {
                //                 Promise.resolve(this.configureAPIGatewaySettingsWithMethods(timeStamp)).then(gatewayResponse => {
                //                   this.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI, timeStamp);
                //                 }, error => {
                //                   Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', crudAPI, error.status, '', '', error.statusText)).then(response => {
                //                     this.auditListenerService.auditListener.emit({
                //                       type: 'auditLog',
                //                       category: 'isAuditForDataAccessAdvanced',
                //                       payload: response
                //                     });
                //                   });
                //                   this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                //                     info:'Setting up API with Gateway configurations',
                //                     icon: 'fa fa-shield',
                //                     description: error,
                //                     type:'fatal'}, timeStamp, 'deploy');
                //                   this.loading = false;
                //                   this.closeNonWSDialogBox();
                //
                //                   // that.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
                //                 });
                //               }
                //             } else {
                //               Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', crudAPI, 400, '', '', 'Selected API gateway is diabled.')).then(response => {
                //                 this.auditListenerService.auditListener.emit({
                //                   type: 'auditLog',
                //                   category: 'isAuditForDataAccessAdvanced',
                //                   payload: response
                //                 });
                //               });
                //               this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                //                 info:'Setting up API with Gateway configurations',
                //                 icon: 'fa fa-shield',
                //                 description: 'The selected API Gateway is disabled. Please enable this API Gateway in the admin settings or deploy with different API Gateway',
                //                 type:'fatal'}, timeStamp, 'deploy');
                //               this.loading = false;
                //               this.closeNonWSDialogBox();
                //               // this.platform.openSnackBar('The selected API Gateway is disabled. Please enable this API Gateway in the admin settings or deploy with different API Gateway', 'Error', {
                //               //   duration: 5000,
                //               //   verticalPosition: 'top',
                //               //   horizontalPosition: 'center'
                //               // });
                //             }
                //           } else {
                //             this.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI, timeStamp);
                //           }
                //           // if (this.ispublished) {
                //           //     // this.configureApiGateway();
                //           //     this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false, methods);
                //           // }
                //
                //           // } else {
                //           //     this.platform.openSnackBar('Special characters are not allowed in attribute name', 'Error', {
                //           //         duration: 5000,
                //           //         verticalPosition: 'top',
                //           //         horizontalPosition: 'center'
                //           //     });
                //           // }
                //         } else {
                //           this.loading = false;
                //           this.closeNonWSDialogBox();
                //           this.logVisible = false;
                //           Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                //             this.auditListenerService.auditListener.emit({
                //               type: 'auditLog',
                //               category: 'isAuditForDataAccessAdvanced',
                //               payload: response
                //             });
                //           });
                //           this.platform.openSnackBar('Special characters are not allowed at the beginning of a table name.', 'Error', {
                //             duration: 5000,
                //             verticalPosition: 'top',
                //             horizontalPosition: 'center'
                //           });
                //         }
                //       } else {
                //         this.loading = false;
                //         this.closeNonWSDialogBox();
                //         this.logVisible = false;
                //         Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                //           this.auditListenerService.auditListener.emit({
                //             type: 'auditLog',
                //             category: 'isAuditForDataAccessAdvanced',
                //             payload: response
                //           });
                //         });
                //         this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
                //           duration: 5000,
                //           verticalPosition: 'top',
                //           horizontalPosition: 'center'
                //         });
                //       }
                //     } else {
                //       this.loading = false;
                //       this.closeNonWSDialogBox();
                //       Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                //         this.auditListenerService.auditListener.emit({
                //           type: 'auditLog',
                //           category: 'isAuditForDataAccessAdvanced',
                //           payload: response
                //         });
                //       });
                //       this.logVisible = false;
                //       this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
                //         duration: 5000,
                //         verticalPosition: 'top',
                //         horizontalPosition: 'center'
                //       });
                //     }
                //
                //   } else {
                //     this.loading = false;
                //     this.closeNonWSDialogBox();
                //     Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                //       this.auditListenerService.auditListener.emit({
                //         type: 'auditLog',
                //         category: 'isAuditForDataAccessAdvanced',
                //         payload: response
                //       });
                //     });
                //   }
                // });
            }
        } else {
            this.loading = false;
            Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create, 'DEPLOY', 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                this.auditListenerService.auditListener.emit({
                    type: 'auditLog',
                    category: 'isAuditForDataAccessAdvanced',
                    payload: response
                });
            });
            if (this.entityName === undefined || this.entityName === null || this.entityName.length === 0 ||
                vers === undefined || vers === null || vers === 0 ||
                category === undefined || category === null || category.length === 0 ||
                this.methodType === undefined || this.methodType === null || this.methodType.length === 0 ||
                this.selectDatabase === undefined || this.selectDatabase === null || this.selectDatabase.length === 0 ||
                this.tableName === undefined || this.tableName === null || this.tableName.length === 0) {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (!(this.apiByDefinition && this.apiByDefinition.length && this.apiByDefinition[0].attributeName !== null)) {
                this.platform.openSnackBar('Please define a valid schema.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (!(this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95)) {
                this.platform.openSnackBar('Please enter a valid ' + this.tableLabelName, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }

    }

    constructKeyValueGatewayConfigurations(configuredGatewaySettings) {
        const gatewaySettings = [];
        for (const plugin of configuredGatewaySettings) {
            if (plugin) {
                const gatewaySetting = {
                    config: {}
                };
                if (plugin['name'] === 'rate-limiting') {
                    gatewaySetting['protocols'] = ['http', 'https'];
                }
                gatewaySetting['name'] = plugin['name'];
                gatewaySetting['enabled'] = plugin['enabled'];
                for (const config of plugin['config']) {
                    if (config) {
                        if (config['type'] === 'array_string') {
                            if (config['value'] && config['value'] !== null && config['value'] !== undefined) {
                                gatewaySetting.config[config['parameter']] = config['value'].split(',');
                            } else {
                                if (plugin['name'] === 'cors') {
                                    if (config['parameter'] === 'methods' && (config['value'] === undefined || config['value'] === [] || config['value'] === null)) {
                                        gatewaySetting.config[config['parameter']] = ['GET', 'PUT', 'POST', 'PATCH', 'DELETE', 'OPTIONS'];
                                    } else {
                                        gatewaySetting.config[config['parameter']] = config['value'];
                                    }
                                } else {
                                    gatewaySetting.config[config['parameter']] = config['value'];
                                }
                            }
                        } else {
                            gatewaySetting.config[config['parameter']] = config['value'];
                        }
                    }
                }
                gatewaySettings.push(gatewaySetting);
            }
        }
        return gatewaySettings;
    }

    insertEntity(partner, account, crudAPI, timeStamp) {
        const that = this;
        this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
            info: 'Setting up API with Gateway configurations',
            icon: 'fa fa-shield',
            type: 'initial'
        }, timeStamp, 'deploy');

        // this.confPost.insertEntity(partner, account, crudAPI).subscribe(async data => {
        //   if (data && data['message'] === 'API already exists.') {
        //     // this.displaySnackBarWithWS('Error', 5000, data['message']);
        //     this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
        //       info:'Setting up API with Gateway configurations',
        //       icon: 'fa fa-shield',
        //       description: data['message'],
        //       type:'fatal'}, timeStamp, 'deploy');
        //     this.save = false;
        //     this.loading = false;
        //     this.closeNonWSDialogBox();
        //     // this.platform.openSnackBar(data['message'], 'Error', {
        //     //   duration: 5000,
        //     //   verticalPosition: 'top',
        //     //   horizontalPosition: 'center'
        //     // });
        //     Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', crudAPI, 400, '', '', 'API already exists')).then(response => {
        //       this.auditListenerService.auditListener.emit({
        //         type: 'auditLog',
        //         category: 'isAuditForDataAccessAdvanced',
        //         payload: response
        //       });
        //     });
        //   } else {
        //     this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
        //       info:'Setting up API with Gateway configurations',
        //       icon: 'fa fa-shield',
        //       type:'success'}, timeStamp, 'deploy');
        //     this.platform.createAPIAuditLog(partner, account, crudAPI['entityname'], crudAPI['version'], 'DAAS', crudAPI);
        //     // this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DEPLOYMENT, {
        //     //   info: 'Deploying API',
        //     //   type: 'initial',
        //     //   icon: 'fa fa-cogs'
        //     // }, timeStamp, 'deploy');
        //     // this.platform.publishEventMessage(this.entityName, this.version,'CONFIGURING PLATFORM PERMISSIONS', {info:'Configuring platform permissions for data access service',type:'inital', icon: 'fa fa-cogs'}, timeStamp, 'deploy');
        //     Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_deploy_success', 'INFO', data.status, data.statusText, '', crudAPI, data, this.router.url)).then(response => {
        //       const payloadToSend = {
        //         actions: response
        //       };
        //       this.dataAccessListenerInstance.dataAccessListener.emit({
        //         type: 'audit',
        //         id: localStorage.getItem('IdOfSession'),
        //         payload: payloadToSend
        //       });
        //     });
        //     await this.platform.generateAccountRolePermissionGroupAndPermissions(this.partner, this.account_id, localStorage.getItem('signInEmail'), this.entityName, this.version, 'DAAS', true, timeStamp, 'deploy');
        //     //this.platform.publishEventMessage(this.entityName, this.version,'CONFIGURING PLATFORM PERMISSIONS', {info:'Configuring platform permissions for data access service',type:'success', icon: 'fa fa-cogs'}, timeStamp, 'deploy');
        //     if (this.ispublished) {
        //       this.Blocks = [1, 2, 3, 4, 5];
        //       const blockLength = this.Blocks.length;
        //       const blockStart = this.BlockList[this.Blocks[0]];
        //       const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
        //       this.progress = blockStart;
        //       this.save = true;
        //       if (!this.connection) {
        //         // that.setInterval(blockEnd, true);
        //       }
        //       // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
        //       this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
        //       this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
        //         // localStorage.setItem('dataAccessAPI' , JSON.stringify(data));
        //         this.platform.apiExecutors = data;
        //         // localStorage.setItem('isDataAccessAPISet', 'true');
        //         this.platform.isDataAccessAPISet = 'true';
        //         // localStorage.setItem('updatedDataAccessAPI', JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']}));
        //         this.platform.updatedDataAccessAPI = JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']});
        //       });
        //     } else {
        //       this.Blocks = [1, 2, 3];
        //       this.save = true;
        //       const blockLength = this.Blocks.length;
        //       const blockStart = this.BlockList[this.Blocks[0]];
        //       const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
        //       this.progress = blockStart;
        //       if (!this.connection) {
        //         // that.setInterval(blockEnd, true);
        //       }
        //       // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
        //       this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
        //     }
        //
        //     Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'SUCCESS', crudAPI, data.status, data, data.statusText, '')).then(response => {
        //       this.auditListenerService.auditListener.emit({
        //         type: 'auditLog',
        //         category: 'isAuditForDataAccessAdvanced',
        //         payload: response
        //       });
        //     });
        //     // await this.platform.delay(2000);
        //     // this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_DEPLOYMENT, {info:'Deploying API',type:'success', icon: 'fa fa-cogs'}, timeStamp, 'deploy');
        //     // await this.platform.delay(500);
        //     this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_TESTING, {
        //       info: 'Checking for testcases <br>Testcases found: 0',
        //       icon: 'fa fa-check-square-o',
        //       type: 'initial'}, timeStamp, 'deploy');
        //
        //     this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.API_TESTING, {
        //       info: 'Checking for testcases <br>Testcases found: 0',
        //       icon: 'fa fa-check-square-o',
        //       type: 'success'}, timeStamp, 'deploy');
        //     this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DOCUMENTATION, {
        //       info: 'Generating Documents',
        //       type: 'initial',
        //       icon: 'fa fa-book'
        //     }, timeStamp, 'deploy');
        //     this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_DOCUMENTATION, {
        //       info: 'Generating Documents',
        //       type: 'success',
        //       icon: 'fa fa-book'
        //     }, timeStamp, 'deploy');
        //     this.platform.delay(1500);
        //     this.platform.publishEventMessage(this.entityName, this.version,environment.pubsubtitles.DONE, {info:'',type:'success', icon: 'fa fa-check'}, timeStamp, 'deploy');
        //     // if (this.ispublished) {
        //     //   // this.configureApiGateway();
        //     //   this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false, methods);
        //     // }
        //     this.loading = false;
        //     this.closeNonWSDialogBox();
        //   }
        // },
        //         error => {
        //
        //
        //   this.loading = false;
        //   this.closeNonWSDialogBox();
        //   let errorMessage = '';
        //   if (error.error) {
        //     if (error.error['message']) {
        //       errorMessage = error.error.message;
        //     } else {
        //       errorMessage = error.error;
        //     }
        //   } else {
        //     errorMessage = 'Error while creating the API. Please try again sometime.';
        //   }
        //
        //   Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.daasAdvanced, this.platform.auditLabels.api_create,  'DEPLOY', 'FAIL', crudAPI, error.status, error, '', errorMessage)).then(response => {
        //     this.auditListenerService.auditListener.emit({
        //       type: 'auditLog',
        //       category: 'isAuditForDataAccessAdvanced',
        //       payload: response
        //     });
        //   });
        //
        //   // this.displaySnackBarWithWS('Error', 5000, errorMessage);
        //   this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
        //     info:'Setting up API with Gateway configurations',
        //     icon: 'fa fa-shield',
        //     description: errorMessage,
        //     type:'fatal'}, timeStamp, 'deploy');
        //   this.platform.deleteApiWithDependencies(false, false, true, localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), this.entityName, this.version);
        //   Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'dataaccessapi_create_deploy_failed', 'ERROR', error.status, error.statusText, errorMessage, crudAPI, error, this.router.url)).then(response => {
        //     const payloadToSend = {
        //       actions: response
        //     };
        //     this.dataAccessListenerInstance.dataAccessListener.emit({
        //       type: 'audit',
        //       id: localStorage.getItem('IdOfSession'),
        //       payload: payloadToSend
        //     });
        //   });
        //
        //   this.save = false;
        //   // this.ispublished = false;
        //   // this.platform.openSnackBar('Error while adding Entity', 'Error', {
        //   //     duration: 5000,
        //   //     verticalPosition: 'top',
        //   //     horizontalPosition: 'center'
        //   // });
        //   // this.platform.handleErrorGracefully(error, 'Error while creating the API. Please try again sometime.');
        // });


    }

    configureAPIGatewaySettingsWithMethods(timeStamp) {
        // this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
        //   info: 'Configuring Gateway Settings for the API',
        //   type: 'initial',
        //   icon: 'fa fa-shield'
        // }, timeStamp, 'deploy');

        const entityDetails = {
            'entityName': this.entityName,
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'action': 'deploy',
            'timeStamp': timeStamp
        };
        return new Promise((resolve, reject) => {
            this.kongService.configureAPIGatewayWithMethods(this.apigatewayInstance.gatewayService, this.apigatewayInstance.gatewayRoute, this.constructKeyValueGatewayConfigurations(this.selection), entityDetails).then(response => {
                // this.platform.publishEventMessage(this.entityName, this.version, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                //   info: 'Configuring Gateway Settings for the API',
                //   type: 'success',
                //   icon: 'fa fa-shield'
                // }, timeStamp, 'deploy');
                resolve('success');
            }, error => {
                reject(error);
            });
        });
    }

    getXML() {
        const that = this;
        // xml = `<note><to>User</to><from>Library</from><heading>Message</heading><body>Some XML to convert to JSON!</body></note>`;
        const xml1 = $('.getXML').val().replace(/\s/g, '').trim();
        const parser = new DOMParser();
        const xml = parser.parseFromString(xml1, 'text/xml');
        const obj = this.ngxXml2jsonService.xmlToJson(xml);
        const crudAPI = {
            'entityname': that.entityName,
            'category': ((typeof that.apiCategory) === 'object' ? that.apiCategory['name'] : that.apiCategory),
            'displayname': that.displayName,
            'description': that.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': that.selectDatabase,
            'version': ((typeof that.version) === 'object' ? that.version['name'] : that.version),
            'attributes': obj
        };
        that.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            that.platform.openSnackBar('Entities Added successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            that.showNextPanel = true;

        }, error => {
            that.platform.handleErrorGracefully(error, 'Error while adding Entity. Please try again sometime.');
        });
    }

    createApiFromYaml() {
        this.confPost.createAPIFromYaml(localStorage.getItem('partner'), localStorage.getItem('account'), this.yamlData).subscribe(data => {
            this.platform.openSnackBar('APIs have been created from YAML successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.showNextPanel = true;

        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while creating APIs from YAML. Please try again sometime.');
        });
    }

    getJSON() {
        this.loading = true;
        this.save = false;
        const that = this;
        const crudAPI = {
            'entityname': this.entityName,
            'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': this.selectDatabase,
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'attributes': this.editor.get()
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            if (data && data['message'] === 'API already exists.') {
                this.save = false;
                this.loading = false;
                this.platform.openSnackBar(data['message'], 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                if (this.ispublished) {
                    this.Blocks = [1, 2, 3, 4, 5];
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    this.save = true;
                    that.setInterval(blockEnd, true);
                } else {
                    this.Blocks = [1, 2, 3];
                    this.save = true;
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    that.setInterval(blockEnd, false);
                }
            }

        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while adding Entity. Please try again after sometime.');
        });
        if (this.ispublished) {
            // this.configureApiGateway();
            this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false);
        }
    }

    addHeaders() {
        const tr = '<tr>\n' +
            '              <td>\n' +
            '                <input type="text" placeholder="key" class="form-control">\n' +
            '              </td>\n' +
            '              <td>\n' +
            '                <input type="text" placeholder="value" class="form-control">\n' +
            '              </td>\n' +
            '              <td>\n' +
            '                <i class="fa fa-minus-square removeHeader"></i>\n' +
            '              </td>\n' +
            '            </tr>';
        $('#APIheader').find('tbody').append(tr);
    }

    copyMessage(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(val).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        // alert('CURL command copied to clipboard');
        this.platform.openSnackBar('CURL command copied to clipboard', 'Info', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    getAPI() {
        const that = this;
        this.loading = true;
        this.save = false;
        this.buttonClick = true;
        this.error = false;
        const APIUrl = $('#APIUrl').val();
        const dataroot = $('#dataroot').val();
        const Header = [];
        Header.push({
            'Content-Type': 'application/json'
        });
        $('#APIheader').find('tbody').find('tr').each(function () {
            const header = {};
            if ($(this).find('td:first').find('input').val().trim() !== '') {
                header[$(this).find('td:first').find('input').val().trim()] = $(this).find('td:eq(1)').find('input').val().trim();
                Header.push(header);
            }
        });
        const crudAPI = {
            'entityname': this.entityName,
            'importData': this.importData,
            'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': (this.selectDatabase === null ? 'default' : this.selectDatabase),
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'APIUrl': APIUrl,
            'dataroot': dataroot,
            'Header': Header
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        this.confPost.createAPI(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            if (data && data['message'] === 'API already exists.') {
                this.save = false;
                this.loading = false;
                this.closeNonWSDialogBox();
                this.platform.openSnackBar(data['message'], 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                if (this.ispublished) {
                    this.Blocks = [1, 2, 3, 4, 5];
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    this.save = true;
                    that.setInterval(blockEnd, true);
                    //  setInterval(() => this.manageProgress(blockEnd, false), 1000);
                } else {
                    this.Blocks = [1, 2, 3];
                    this.save = true;
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    that.setInterval(blockEnd, false);
                    // setInterval(() => this.manageProgress(blockEnd, false), 1000);
                    /* this.platform.openSnackBar('API has been created successfully', 'Success', {
               duration: 5000,
               verticalPosition: 'top',
               horizontalPosition: 'center'
           });*/
                }
            }
        }, error => {
            this.APILoading = true;
            this.error = true;
            this.platform.handleErrorGracefully(error, 'Error while creating API. Please try again after sometime.');
        });

        if (this.ispublished) {
            // this.configureApiGateway();
            this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false);

        }
    }

    navigateDataView() {
        this.router.navigate(['/api'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('account'),
                    entity: this.entityName,
                    version: this.version['name']
                }
            });
    }

    navigateAPIReview() {
        this.router.navigate(['/entity/edit'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('account'),
                    entity: this.entityName,
                    version: this.version['name']
                }
            });
    }

    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    manageProgress(target, showPanel) {
        // if (this.progress <= target) {
        //     this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //         let item = data;
        // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
        //     let apiKey = keys['data'][0].key;
        const apiKey = localStorage.getItem('apikey');
        const dialogRef = this.dialog.open(DialogComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
            data: {
                type: 'dataaccess',
                save: true,
                ispublished: this.ispublished,
                gatewayFullUrl: this.gatewayFullUrl,
                Blocks: this.Blocks,
                version: this.version,
                showNextPanel: false,
                partner: this.partner,
                account: this.account_id,
                entityName: this.entityName,
                apiKey: apiKey,
                partnerKey: this.partnerKey
            }
        });
        dialogRef.afterClosed().subscribe(async result => {
            if (result === 'create') {
                await this.router.navigateByUrl('/dataaccessapi');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else if (result === 'edit') {
                this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            } else if (result === 'data') {
                this.router.navigateByUrl('/api?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            } else if (result === 'devex') {
                this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            }
        });
        // });
        // });
        // this.showNextPanel = showPanel;
        this.loading = false;
        this.ngOnDestroy();
        // } else {
        //     this.progress = this.progress + incr;
        // }
        // if (this.progress <= 35) {
        //     this.progressMessage = 'Setting Up API';
        // } else if (this.progress > 35 && this.progress <= 70) {
        //     this.progressMessage = 'Setting Up Database';
        //     /*} else if (this.progress > 70 && this.progress <= 98) {
        //         this.progressMessage = 'Creating dedicated File storage for your account';*/
        // } else if (this.progress > 70) {
        //     this.progressMessage = 'Deploying into Cloud';
        // }
    }

    manageProgressForApi() {
        if (this.progress >= 100) {
            // this.APILoading = true;
            this.showNextPanel = true;
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up API & Schema';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Data';
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    createAPIByDB() {
        this.buttonClickdB = true;
        this.dberror = false;
        const crudAPI = {
            'database_name': this.databaseName,
            'listOfTables': this.listofTables,
            'useReferentialKeys': this.useReferentialKeys,
            'targetDatabase': (this.targetDatabase == null ? 'default' : this.targetDatabase),
            'importData': this.importDataDB
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        this.confPost.createAPIFromDB(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            this.platform.openSnackBar('API Created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.APILoadingdB = true;

        }, error => {
            this.dberror = true;
            this.APILoadingdB = true;
            this.platform.handleErrorGracefully(error, 'Error while creating API. Please try again after sometime.');
        });
    }

    isFamilyString(type): boolean {
        let matched = false;
        if (this.dataTypeFilter && type) {
            for (let i = 0; i < this.dataTypeFilter.length; i++) {
                if (this.dataTypeFilter[i]['data_types'][0]['type'] === type) {
                    if (this.dataTypeFilter[i]['data_types'][0]['family'] === 'String') {
                        matched = true;
                        return true;
                    }
                }
            }
            if (matched === false) {
                return false;
            }
        }
    }

    openAttributeDescriptionDialog(definition) {
        const data = {
            'displayName': definition.displayName,
            'description': definition.description,
            'dataStoragePolicy': definition.dataStoragePolicy,
            'apiAccessPolicy': definition.apiAccessPolicy,
            'displayPolicy': definition.displayPolicy,
            'definitionType': definition.type,
            'datatypeFilter': this.dataTypeFilter,
            'compliances': definition.compliances ? definition.compliances : []
        };
        const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
            definition.displayName = data.displayName;
            definition.description = data.description;
            definition.dataStoragePolicy = data.dataStoragePolicy;
            definition.apiAccessPolicy = data.apiAccessPolicy;
            definition.displayPolicy = data.displayPolicy;
            definition.compliances = data.compliances;
        });
    }

    private _filter(name: string): ICategory[] {
        const filterValue = name.toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private _versionFilter(name: string): EntityVersions[] {
        const filterValue = name.toLowerCase();

        return this.entityVersions.filter(version => version.name.toLowerCase().indexOf(filterValue) === 0);
    }

    getRegion(val) {
        return this.platform.getRegion(val);
    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    generateExecutorAgain() {
        window.location.reload();
    }

    createMarginRight() {
        document.getElementById('view:data_access_api_advanced').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:data_access_api_advanced').style.marginRight = '0px';
    }
}
